// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  type UseMutationOptions,
  infiniteQueryOptions,
  queryOptions,
} from '@tanstack/react-query';

import { client } from '../client.gen';
import {
  type Options,
  addRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPost,
  addUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPost,
  batchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPost,
  bulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPost,
  bulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPost,
  bulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPost,
  complexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPost,
  createClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPost,
  createCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPost,
  createExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPost,
  createExploreImageV1ExploreImagesPost,
  createExplorePdpV1ExplorePdpsPost,
  createIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPost,
  createImageClassificationV1AssetsImagesImageIdClassificationPost,
  createImageScoreV1AssetsImagesImageIdRawScorePost,
  createOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPost,
  createOrganizationV1OrganizationsPost,
  createPdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPost,
  createPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPost,
  createPdpV1PortfoliosPortfolioIdPdpsPost,
  createQueryV1ExploreQueriesPost,
  createUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPost,
  deleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDelete,
  deleteExploreImageV1ExploreImagesExploreImageIdDelete,
  deleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDelete,
  deleteImageGenPromptV1ImageGenPromptsPromptIdDelete,
  deleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDelete,
  deleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDelete,
  deletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDelete,
  deletePdpV1PortfoliosPortfolioIdPdpsPdpIdDelete,
  deleteUserV1UsersUserIdDelete,
  exchangeTokenV1OrganizationsOrganizationIdAuthorizePost,
  exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGet,
  generatePromptsForImageV1ImagesImageIdGeneratePromptsPost,
  getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGet,
  getAudienceV1AudiencesAudienceIdGet,
  getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGet,
  getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGet,
  getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGet,
  getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGet,
  getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGet,
  getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGet,
  getExploreImageV1ExploreImagesExploreImageIdGet,
  getExplorePdpV1ExplorePdpsExplorePdpIdGet,
  getFeatureFlagV1FeatureFlagsFlagGet,
  getIcpProductCategoriesV1IcpProductCategoriesGet,
  getIcpProductCategoriesV1L1ProductCategoriesGet,
  getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGet,
  getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGet,
  getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGet,
  getImageByIdV1ImagesImageIdGet,
  getImageClassificationV1ExploreClassificationsClassificationIdGet,
  getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGet,
  getImageGenPromptV1ImageGenPromptsPromptIdGet,
  getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGet,
  getImageGenPromptsForImageV1ImagesImageIdGenPromptsGet,
  getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGet,
  getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGet,
  getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGet,
  getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGet,
  getOrganizationV1OrganizationsOrgIdGet,
  getOrganizationsForUserV1UsersUserIdOrganizationsGet,
  getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGet,
  getPdpV1PortfoliosPortfolioIdPdpsPdpIdGet,
  getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGet,
  getProductCategoriesV1ProductCategoriesGet,
  getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGet,
  getProductCategoryV1ProductCategoriesCategoryIdGet,
  getQueryV1ExploreQueriesQueryIdGet,
  getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGet,
  getRetailerRegionV1RetailerRegionsRetailerRegionIdGet,
  getRetailersForOrganizationV1OrganizationsOrgIdRetailersGet,
  getScrapedPdpV1PdpsRequestIdGet,
  getUserV1UsersUserIdGet,
  getUsersForOrganizationV1OrganizationsOrganizationIdUsersGet,
  handleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPost,
  healthcheckGet,
  healthcheckHealthcheckGet,
  listClassificationImagesV1ExploreClassificationsClassificationIdImagesGet,
  listExploreImagesV1ExploreImagesGet,
  listFeatureFlagsV1FeatureFlagsGet,
  listImageClassificationsV1ExploreClassificationsGet,
  listRetailerRegionsV1RetailerRegionsGet,
  loginUserV1UsersAuthenticatePost,
  logoutUserV1UsersUserIdLogoutPost,
  readyReadyGet,
  refreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPost,
  removeRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDelete,
  removeUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDelete,
  renameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatch,
  replaceExploreImageV1ExploreImagesExploreImageIdPut,
  resendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePost,
  resetPasswordV1UsersPasswordPut,
  searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGet,
  searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGet,
  searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGet,
  searchImagesV1PortfoliosPortfolioIdAssetsImagesGet,
  searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGet,
  searchPdpsV1PortfoliosPortfolioIdPdpsGet,
  setPasswordV1UsersUserIdPasswordPost,
  ssoAuthorizeV1AuthSsoAuthorizeGet,
  ssoCallbackV1AuthSsoCallbackGet,
  ssoCheckV1AuthSsoCheckGet,
  updateExplorePdpV1ExplorePdpsExplorePdpIdPatch,
  updateImageGenPromptV1ImageGenPromptsPromptIdPatch,
  updateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPut,
  updateOrganizationV1OrganizationsOrgIdPut,
  updatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatch,
  updatePdpV1PortfoliosPortfolioIdPdpsPdpIdPut,
  updateQueryV1ExploreQueriesQueryIdPatch,
  updateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePut,
  uploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPost,
  uploadImageV1PortfoliosPortfolioIdAssetsImagesPost,
} from '../sdk.gen';
import type {
  AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostData,
  AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostError,
  AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostResponse,
  AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostData,
  AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostError,
  AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostResponse,
  BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostData,
  BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostError,
  BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostResponse,
  BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostData,
  BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostError,
  BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostResponse,
  BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostData,
  BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostError,
  BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostResponse,
  BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostData,
  BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostError,
  BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostResponse,
  ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostData,
  ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostError,
  ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostResponse,
  CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostData,
  CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostError,
  CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostResponse,
  CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostData,
  CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostError,
  CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostResponse,
  CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostData,
  CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostError,
  CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostResponse,
  CreateExploreImageV1ExploreImagesPostData,
  CreateExploreImageV1ExploreImagesPostError,
  CreateExploreImageV1ExploreImagesPostResponse,
  CreateExplorePdpV1ExplorePdpsPostData,
  CreateExplorePdpV1ExplorePdpsPostError,
  CreateExplorePdpV1ExplorePdpsPostResponse,
  CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostData,
  CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostError,
  CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostResponse,
  CreateImageClassificationV1AssetsImagesImageIdClassificationPostData,
  CreateImageClassificationV1AssetsImagesImageIdClassificationPostError,
  CreateImageClassificationV1AssetsImagesImageIdClassificationPostResponse,
  CreateImageScoreV1AssetsImagesImageIdRawScorePostData,
  CreateImageScoreV1AssetsImagesImageIdRawScorePostError,
  CreateImageScoreV1AssetsImagesImageIdRawScorePostResponse,
  CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostData,
  CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostError,
  CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostResponse,
  CreateOrganizationV1OrganizationsPostData,
  CreateOrganizationV1OrganizationsPostError,
  CreateOrganizationV1OrganizationsPostResponse,
  CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostData,
  CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostError,
  CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostResponse,
  CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostData,
  CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostError,
  CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostResponse,
  CreatePdpV1PortfoliosPortfolioIdPdpsPostData,
  CreatePdpV1PortfoliosPortfolioIdPdpsPostError,
  CreatePdpV1PortfoliosPortfolioIdPdpsPostResponse,
  CreateQueryV1ExploreQueriesPostData,
  CreateQueryV1ExploreQueriesPostError,
  CreateQueryV1ExploreQueriesPostResponse,
  CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostData,
  CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostError,
  CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostResponse,
  DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteData,
  DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteError,
  DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteResponse,
  DeleteExploreImageV1ExploreImagesExploreImageIdDeleteData,
  DeleteExploreImageV1ExploreImagesExploreImageIdDeleteError,
  DeleteExploreImageV1ExploreImagesExploreImageIdDeleteResponse,
  DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData,
  DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteError,
  DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponse,
  DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteData,
  DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteError,
  DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteResponse,
  DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteData,
  DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteError,
  DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteResponse,
  DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteData,
  DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteError,
  DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteResponse,
  DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteData,
  DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteError,
  DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteResponse,
  DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteData,
  DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteError,
  DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteResponse,
  DeleteUserV1UsersUserIdDeleteData,
  DeleteUserV1UsersUserIdDeleteError,
  DeleteUserV1UsersUserIdDeleteResponse,
  ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostData,
  ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostError,
  ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostResponse,
  ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetData,
  ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetError,
  ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetResponse,
  GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostData,
  GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostError,
  GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostResponse,
  GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetData,
  GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetError,
  GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetResponse,
  GetAudienceV1AudiencesAudienceIdGetData,
  GetAudienceV1AudiencesAudienceIdGetError,
  GetAudienceV1AudiencesAudienceIdGetResponse,
  GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetData,
  GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetError,
  GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetResponse,
  GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData,
  GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetError,
  GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetResponse,
  GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetData,
  GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetError,
  GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetResponse,
  GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetData,
  GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetError,
  GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetResponse,
  GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetData,
  GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetError,
  GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetResponse,
  GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetData,
  GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetError,
  GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetResponse,
  GetExploreImageV1ExploreImagesExploreImageIdGetData,
  GetExploreImageV1ExploreImagesExploreImageIdGetError,
  GetExploreImageV1ExploreImagesExploreImageIdGetResponse,
  GetExplorePdpV1ExplorePdpsExplorePdpIdGetData,
  GetExplorePdpV1ExplorePdpsExplorePdpIdGetError,
  GetExplorePdpV1ExplorePdpsExplorePdpIdGetResponse,
  GetFeatureFlagV1FeatureFlagsFlagGetData,
  GetFeatureFlagV1FeatureFlagsFlagGetError,
  GetFeatureFlagV1FeatureFlagsFlagGetResponse,
  GetIcpProductCategoriesV1IcpProductCategoriesGetData,
  GetIcpProductCategoriesV1IcpProductCategoriesGetError,
  GetIcpProductCategoriesV1IcpProductCategoriesGetResponse,
  GetIcpProductCategoriesV1L1ProductCategoriesGetData,
  GetIcpProductCategoriesV1L1ProductCategoriesGetError,
  GetIcpProductCategoriesV1L1ProductCategoriesGetResponse,
  GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetData,
  GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetError,
  GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetResponse,
  GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetData,
  GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetError,
  GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetResponse,
  GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetData,
  GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetError,
  GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetResponse,
  GetImageByIdV1ImagesImageIdGetData,
  GetImageByIdV1ImagesImageIdGetError,
  GetImageByIdV1ImagesImageIdGetResponse,
  GetImageClassificationV1ExploreClassificationsClassificationIdGetData,
  GetImageClassificationV1ExploreClassificationsClassificationIdGetError,
  GetImageClassificationV1ExploreClassificationsClassificationIdGetResponse,
  GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetData,
  GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetError,
  GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetResponse,
  GetImageGenPromptV1ImageGenPromptsPromptIdGetData,
  GetImageGenPromptV1ImageGenPromptsPromptIdGetError,
  GetImageGenPromptV1ImageGenPromptsPromptIdGetResponse,
  GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData,
  GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetError,
  GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetResponse,
  GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData,
  GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetError,
  GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetResponse,
  GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetData,
  GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetError,
  GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetResponse,
  GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetData,
  GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetError,
  GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetResponse,
  GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetData,
  GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetError,
  GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetResponse,
  GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetData,
  GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetError,
  GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetResponse,
  GetOrganizationV1OrganizationsOrgIdGetData,
  GetOrganizationV1OrganizationsOrgIdGetError,
  GetOrganizationV1OrganizationsOrgIdGetResponse,
  GetOrganizationsForUserV1UsersUserIdOrganizationsGetData,
  GetOrganizationsForUserV1UsersUserIdOrganizationsGetError,
  GetOrganizationsForUserV1UsersUserIdOrganizationsGetResponse,
  GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetData,
  GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetError,
  GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetResponse,
  GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetData,
  GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetError,
  GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetResponse,
  GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData,
  GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetError,
  GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetResponse,
  GetProductCategoriesV1ProductCategoriesGetData,
  GetProductCategoriesV1ProductCategoriesGetError,
  GetProductCategoriesV1ProductCategoriesGetResponse,
  GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetData,
  GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetError,
  GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetResponse,
  GetProductCategoryV1ProductCategoriesCategoryIdGetData,
  GetProductCategoryV1ProductCategoriesCategoryIdGetError,
  GetProductCategoryV1ProductCategoriesCategoryIdGetResponse,
  GetQueryV1ExploreQueriesQueryIdGetData,
  GetQueryV1ExploreQueriesQueryIdGetError,
  GetQueryV1ExploreQueriesQueryIdGetResponse,
  GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetData,
  GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetError,
  GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetResponse,
  GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetData,
  GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetError,
  GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetResponse,
  GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetData,
  GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetError,
  GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetResponse,
  GetScrapedPdpV1PdpsRequestIdGetData,
  GetScrapedPdpV1PdpsRequestIdGetError,
  GetScrapedPdpV1PdpsRequestIdGetResponse,
  GetUserV1UsersUserIdGetData,
  GetUserV1UsersUserIdGetError,
  GetUserV1UsersUserIdGetResponse,
  GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData,
  GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetError,
  GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetResponse,
  HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostData,
  HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostError,
  HealthcheckGetData,
  HealthcheckGetResponse,
  HealthcheckHealthcheckGetData,
  HealthcheckHealthcheckGetResponse,
  ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData,
  ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetError,
  ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetResponse,
  ListExploreImagesV1ExploreImagesGetData,
  ListExploreImagesV1ExploreImagesGetError,
  ListExploreImagesV1ExploreImagesGetResponse,
  ListFeatureFlagsV1FeatureFlagsGetData,
  ListFeatureFlagsV1FeatureFlagsGetResponse,
  ListImageClassificationsV1ExploreClassificationsGetData,
  ListImageClassificationsV1ExploreClassificationsGetResponse,
  ListRetailerRegionsV1RetailerRegionsGetData,
  ListRetailerRegionsV1RetailerRegionsGetError,
  ListRetailerRegionsV1RetailerRegionsGetResponse,
  LoginUserV1UsersAuthenticatePostData,
  LoginUserV1UsersAuthenticatePostError,
  LoginUserV1UsersAuthenticatePostResponse,
  LogoutUserV1UsersUserIdLogoutPostData,
  LogoutUserV1UsersUserIdLogoutPostError,
  ReadyReadyGetData,
  ReadyReadyGetResponse,
  RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostData,
  RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostError,
  RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteData,
  RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteError,
  RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteResponse,
  RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteData,
  RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteError,
  RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteResponse,
  RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchData,
  RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchError,
  RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchResponse,
  ReplaceExploreImageV1ExploreImagesExploreImageIdPutData,
  ReplaceExploreImageV1ExploreImagesExploreImageIdPutError,
  ReplaceExploreImageV1ExploreImagesExploreImageIdPutResponse,
  ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostData,
  ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostError,
  ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostResponse,
  ResetPasswordV1UsersPasswordPutData,
  ResetPasswordV1UsersPasswordPutError,
  SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData,
  SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetError,
  SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetResponse,
  SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData,
  SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetError,
  SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetResponse,
  SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData,
  SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetError,
  SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetResponse,
  SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData,
  SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetError,
  SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetResponse,
  SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData,
  SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetError,
  SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetResponse,
  SearchPdpsV1PortfoliosPortfolioIdPdpsGetData,
  SearchPdpsV1PortfoliosPortfolioIdPdpsGetError,
  SearchPdpsV1PortfoliosPortfolioIdPdpsGetResponse,
  SetPasswordV1UsersUserIdPasswordPostData,
  SetPasswordV1UsersUserIdPasswordPostError,
  SetPasswordV1UsersUserIdPasswordPostResponse,
  SsoAuthorizeV1AuthSsoAuthorizeGetData,
  SsoAuthorizeV1AuthSsoAuthorizeGetError,
  SsoAuthorizeV1AuthSsoAuthorizeGetResponse,
  SsoCallbackV1AuthSsoCallbackGetData,
  SsoCallbackV1AuthSsoCallbackGetError,
  SsoCheckV1AuthSsoCheckGetData,
  SsoCheckV1AuthSsoCheckGetError,
  SsoCheckV1AuthSsoCheckGetResponse,
  UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchData,
  UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchError,
  UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchResponse,
  UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchData,
  UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchError,
  UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutData,
  UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutError,
  UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutResponse,
  UpdateOrganizationV1OrganizationsOrgIdPutData,
  UpdateOrganizationV1OrganizationsOrgIdPutError,
  UpdateOrganizationV1OrganizationsOrgIdPutResponse,
  UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchData,
  UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchError,
  UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchResponse,
  UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutData,
  UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutError,
  UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutResponse,
  UpdateQueryV1ExploreQueriesQueryIdPatchData,
  UpdateQueryV1ExploreQueriesQueryIdPatchError,
  UpdateQueryV1ExploreQueriesQueryIdPatchResponse,
  UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutData,
  UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutError,
  UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutResponse,
  UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostData,
  UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostError,
  UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostResponse,
  UploadImageV1PortfoliosPortfolioIdAssetsImagesPostData,
  UploadImageV1PortfoliosPortfolioIdAssetsImagesPostError,
  UploadImageV1PortfoliosPortfolioIdAssetsImagesPostResponse,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string;
    _infinite?: boolean;
    tags?: ReadonlyArray<string>;
  },
];

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean,
  tags?: ReadonlyArray<string>,
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
  } as QueryKey<TOptions>[0];
  if (infinite) {
    params._infinite = infinite;
  }
  if (tags) {
    params.tags = tags;
  }
  if (options?.body) {
    params.body = options.body;
  }
  if (options?.headers) {
    params.headers = options.headers;
  }
  if (options?.path) {
    params.path = options.path;
  }
  if (options?.query) {
    params.query = options.query;
  }
  return [params];
};

export const ssoCheckV1AuthSsoCheckGetQueryKey = (options: Options<SsoCheckV1AuthSsoCheckGetData>) =>
  createQueryKey('ssoCheckV1AuthSsoCheckGet', options);

/**
 * Sso Check
 */
export const ssoCheckV1AuthSsoCheckGetOptions = (options: Options<SsoCheckV1AuthSsoCheckGetData>) =>
  queryOptions<
    SsoCheckV1AuthSsoCheckGetResponse,
    SsoCheckV1AuthSsoCheckGetError,
    SsoCheckV1AuthSsoCheckGetResponse,
    ReturnType<typeof ssoCheckV1AuthSsoCheckGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await ssoCheckV1AuthSsoCheckGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: ssoCheckV1AuthSsoCheckGetQueryKey(options),
  });

export const ssoAuthorizeV1AuthSsoAuthorizeGetQueryKey = (options: Options<SsoAuthorizeV1AuthSsoAuthorizeGetData>) =>
  createQueryKey('ssoAuthorizeV1AuthSsoAuthorizeGet', options);

/**
 * Sso Authorize
 */
export const ssoAuthorizeV1AuthSsoAuthorizeGetOptions = (options: Options<SsoAuthorizeV1AuthSsoAuthorizeGetData>) =>
  queryOptions<
    SsoAuthorizeV1AuthSsoAuthorizeGetResponse,
    SsoAuthorizeV1AuthSsoAuthorizeGetError,
    SsoAuthorizeV1AuthSsoAuthorizeGetResponse,
    ReturnType<typeof ssoAuthorizeV1AuthSsoAuthorizeGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await ssoAuthorizeV1AuthSsoAuthorizeGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: ssoAuthorizeV1AuthSsoAuthorizeGetQueryKey(options),
  });

export const ssoCallbackV1AuthSsoCallbackGetQueryKey = (options?: Options<SsoCallbackV1AuthSsoCallbackGetData>) =>
  createQueryKey('ssoCallbackV1AuthSsoCallbackGet', options);

/**
 * Sso Callback
 */
export const ssoCallbackV1AuthSsoCallbackGetOptions = (options?: Options<SsoCallbackV1AuthSsoCallbackGetData>) =>
  queryOptions<
    unknown,
    SsoCallbackV1AuthSsoCallbackGetError,
    unknown,
    ReturnType<typeof ssoCallbackV1AuthSsoCallbackGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await ssoCallbackV1AuthSsoCallbackGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: ssoCallbackV1AuthSsoCallbackGetQueryKey(options),
  });

export const getAudienceV1AudiencesAudienceIdGetQueryKey = (
  options: Options<GetAudienceV1AudiencesAudienceIdGetData>,
) => createQueryKey('getAudienceV1AudiencesAudienceIdGet', options);

/**
 * Get Audience
 */
export const getAudienceV1AudiencesAudienceIdGetOptions = (options: Options<GetAudienceV1AudiencesAudienceIdGetData>) =>
  queryOptions<
    GetAudienceV1AudiencesAudienceIdGetResponse,
    GetAudienceV1AudiencesAudienceIdGetError,
    GetAudienceV1AudiencesAudienceIdGetResponse,
    ReturnType<typeof getAudienceV1AudiencesAudienceIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getAudienceV1AudiencesAudienceIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getAudienceV1AudiencesAudienceIdGetQueryKey(options),
  });

export const getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetQueryKey = (
  options: Options<GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetData>,
) => createQueryKey('getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGet', options);

/**
 * Get Artifact
 *
 * Returns a signed URL to an image's artifact
 */
export const getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetOptions = (
  options: Options<GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetData>,
) =>
  queryOptions<
    GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetResponse,
    GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetError,
    GetArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetResponse,
    ReturnType<typeof getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getArtifactV1PortfoliosPortfolioIdAssetsImagesImageIdArtifactsArtifactTypeGetQueryKey(options),
  });

export const getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetQueryKey = (
  options: Options<GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetData>,
) => createQueryKey('getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGet', options);

/**
 * Get Bulk Refresh Job
 */
export const getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetOptions = (
  options: Options<GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetData>,
) =>
  queryOptions<
    GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetResponse,
    GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetError,
    GetBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetResponse,
    ReturnType<typeof getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBulkRefreshJobV1PortfoliosPortfolioIdBulkRefreshBulkRefreshIdGetQueryKey(options),
  });

/**
 * Bulk Refresh Pdps
 */
export const bulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostMutation = (
  options?: Partial<Options<BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostData>>,
): UseMutationOptions<
  BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostResponse,
  BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostError,
  Options<BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostData>
> => {
  const mutationOptions: UseMutationOptions<
    BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostResponse,
    BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostError,
    Options<BulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkRefreshPdpsV1PortfoliosPortfolioIdBulkRefreshPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Import Csv
 *
 * Bulk imports PDPs from a CSV file containing item IDs, retailer, and region.
 *
 * Accepts a CSV file with 3 columns:
 * - Column 1: Item ID (format depends on retailer; for Amazon, this is an ASIN)
 * - Column 2: Retailer (e.g., "amazon")
 * - Column 3: Region (e.g., "us")
 *
 * Returns:
 * BulkImportResponse with bulk import ID, message, and counts
 *
 * Raises:
 * 400: Invalid file format, size, row count, missing retailer/region, or unsupported retailer
 * 429: Rate limit exceeded (1 import per minute per user)
 * 500: Internal server errors
 */
export const bulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostMutation = (
  options?: Partial<Options<BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostData>>,
): UseMutationOptions<
  BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostResponse,
  BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostError,
  Options<BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostData>
> => {
  const mutationOptions: UseMutationOptions<
    BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostResponse,
    BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostError,
    Options<BulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkImportCsvV1PortfoliosPortfolioIdBulkImportCsvPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetQueryKey = (
  options: Options<GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetData>,
) => createQueryKey('getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGet', options);

/**
 * Get Bulk Import
 *
 * Get status and details of a bulk import job.
 *
 * Returns:
 * BulkImportView with import status, counts, and completion information
 */
export const getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetOptions = (
  options: Options<GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetData>,
) =>
  queryOptions<
    GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetResponse,
    GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetError,
    GetBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetResponse,
    ReturnType<typeof getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBulkImportV1PortfoliosPortfolioIdBulkImportBulkImportIdGetQueryKey(options),
  });

export const searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetQueryKey = (
  options: Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>,
) => createQueryKey('searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGet', options);

/**
 * Search Collections
 */
export const searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetOptions = (
  options: Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>,
) =>
  queryOptions<
    SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetResponse,
    SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetError,
    SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetResponse,
    ReturnType<typeof searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetQueryKey(options),
  });

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(
  queryKey: QueryKey<Options>,
  page: K,
) => {
  const params = { ...queryKey[0] };
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any),
    };
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers,
    };
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any),
    };
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any),
    };
  }
  return params as unknown as typeof page;
};

export const searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetInfiniteQueryKey = (
  options: Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>,
): QueryKey<Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>> =>
  createQueryKey('searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGet', options, true);

/**
 * Search Collections
 */
export const searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetInfiniteOptions = (
  options: Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>,
) =>
  infiniteQueryOptions<
    SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetResponse,
    SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetError,
    InfiniteData<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetResponse>,
    QueryKey<Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>>,
    | number
    | Pick<
        QueryKey<Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SearchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: searchCollectionsV1PortfoliosPortfolioIdAssetsImagesCollectionsGetInfiniteQueryKey(options),
    },
  );

/**
 * Create Collection
 */
export const createCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostMutation = (
  options?: Partial<Options<CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostData>>,
): UseMutationOptions<
  CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostResponse,
  CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostError,
  Options<CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostResponse,
    CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostError,
    Options<CreateCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Collection
 *
 * Delete a collection and all its images.
 */
export const deleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteMutation = (
  options?: Partial<Options<DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteData>>,
): UseMutationOptions<
  DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteResponse,
  DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteError,
  Options<DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteResponse,
    DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteError,
    Options<DeleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetQueryKey = (
  options: Options<GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetData>,
) => createQueryKey('getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGet', options);

/**
 * Get Collection
 */
export const getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetOptions = (
  options: Options<GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetData>,
) =>
  queryOptions<
    GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetResponse,
    GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetError,
    GetCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetResponse,
    ReturnType<typeof getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdGetQueryKey(options),
  });

/**
 * Rename Collection
 *
 * Rename a collection.
 */
export const renameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchMutation = (
  options?: Partial<Options<RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchData>>,
): UseMutationOptions<
  RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchResponse,
  RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchError,
  Options<RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchData>
> => {
  const mutationOptions: UseMutationOptions<
    RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchResponse,
    RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchError,
    Options<RenameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await renameCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdPatch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Image From Collection
 *
 * Delete a single image from a collection.
 */
export const deleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteMutation =
  (
    options?: Partial<
      Options<DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData>
    >,
  ): UseMutationOptions<
    DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponse,
    DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteError,
    Options<DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteResponse,
      DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteError,
      Options<DeleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDeleteData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await deleteImageFromCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesImageIdDelete({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

export const searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetQueryKey = (
  options: Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>,
) =>
  createQueryKey('searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGet', options);

/**
 * Search Collection Images
 *
 * Retrieves images within a collection with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID to find children of a specific parent
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 */
export const searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetOptions = (
  options: Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>,
) =>
  queryOptions<
    SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetResponse,
    SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetError,
    SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetResponse,
    ReturnType<typeof searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey:
      searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetQueryKey(options),
  });

export const searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetInfiniteQueryKey =
  (
    options: Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>,
  ): QueryKey<Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>> =>
    createQueryKey(
      'searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGet',
      options,
      true,
    );

/**
 * Search Collection Images
 *
 * Retrieves images within a collection with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID to find children of a specific parent
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 */
export const searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetInfiniteOptions =
  (options: Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>) =>
    infiniteQueryOptions<
      SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetResponse,
      SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetError,
      InfiniteData<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetResponse>,
      QueryKey<Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>>,
      | number
      | Pick<
          QueryKey<
            Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>
          >[0],
          'body' | 'headers' | 'path' | 'query'
        >
    >(
      // @ts-ignore
      {
        queryFn: async ({ pageParam, queryKey, signal }) => {
          // @ts-ignore
          const page: Pick<
            QueryKey<
              Options<SearchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetData>
            >[0],
            'body' | 'headers' | 'path' | 'query'
          > =
            typeof pageParam === 'object'
              ? pageParam
              : {
                  query: {
                    offset: pageParam,
                  },
                };
          const params = createInfiniteParams(queryKey, page);
          const { data } =
            await searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGet({
              ...options,
              ...params,
              signal,
              throwOnError: true,
            });
          return data;
        },
        queryKey:
          searchCollectionImagesV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesGetInfiniteQueryKey(
            options,
          ),
      },
    );

/**
 * Upload Image To Collection
 */
export const uploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostMutation = (
  options?: Partial<
    Options<UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostData>
  >,
): UseMutationOptions<
  UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostResponse,
  UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostError,
  Options<UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostResponse,
    UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostError,
    Options<UploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await uploadImageToCollectionV1PortfoliosPortfolioIdAssetsImagesCollectionsCollectionIdImagesPost({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

export const getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetQueryKey = (
  options: Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>,
) => createQueryKey('getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGet', options);

/**
 * Get Benchmark Images
 *
 * Retrieves the benchmark images for a product category
 */
export const getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetOptions = (
  options: Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>,
) =>
  queryOptions<
    GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetResponse,
    GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetError,
    GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetResponse,
    ReturnType<typeof getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetQueryKey(options),
  });

export const getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetInfiniteQueryKey = (
  options: Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>,
): QueryKey<Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>> =>
  createQueryKey('getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGet', options, true);

/**
 * Get Benchmark Images
 *
 * Retrieves the benchmark images for a product category
 */
export const getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetInfiniteOptions = (
  options: Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>,
) =>
  infiniteQueryOptions<
    GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetResponse,
    GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetError,
    InfiniteData<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetResponse>,
    QueryKey<Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>>,
    | number
    | Pick<
        QueryKey<Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getBenchmarkImagesV1ProductCategoriesProductCategoryIdBenchmarkImagesGetInfiniteQueryKey(options),
    },
  );

export const listExploreImagesV1ExploreImagesGetQueryKey = (
  options?: Options<ListExploreImagesV1ExploreImagesGetData>,
) => createQueryKey('listExploreImagesV1ExploreImagesGet', options);

/**
 * List Explore Images
 *
 * List ExploreImage records with optional filters for idempotency checks.
 */
export const listExploreImagesV1ExploreImagesGetOptions = (
  options?: Options<ListExploreImagesV1ExploreImagesGetData>,
) =>
  queryOptions<
    ListExploreImagesV1ExploreImagesGetResponse,
    ListExploreImagesV1ExploreImagesGetError,
    ListExploreImagesV1ExploreImagesGetResponse,
    ReturnType<typeof listExploreImagesV1ExploreImagesGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listExploreImagesV1ExploreImagesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listExploreImagesV1ExploreImagesGetQueryKey(options),
  });

export const listExploreImagesV1ExploreImagesGetInfiniteQueryKey = (
  options?: Options<ListExploreImagesV1ExploreImagesGetData>,
): QueryKey<Options<ListExploreImagesV1ExploreImagesGetData>> =>
  createQueryKey('listExploreImagesV1ExploreImagesGet', options, true);

/**
 * List Explore Images
 *
 * List ExploreImage records with optional filters for idempotency checks.
 */
export const listExploreImagesV1ExploreImagesGetInfiniteOptions = (
  options?: Options<ListExploreImagesV1ExploreImagesGetData>,
) =>
  infiniteQueryOptions<
    ListExploreImagesV1ExploreImagesGetResponse,
    ListExploreImagesV1ExploreImagesGetError,
    InfiniteData<ListExploreImagesV1ExploreImagesGetResponse>,
    QueryKey<Options<ListExploreImagesV1ExploreImagesGetData>>,
    number | Pick<QueryKey<Options<ListExploreImagesV1ExploreImagesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListExploreImagesV1ExploreImagesGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listExploreImagesV1ExploreImagesGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listExploreImagesV1ExploreImagesGetInfiniteQueryKey(options),
    },
  );

/**
 * Create Explore Image
 *
 * Create a new ExploreImage record for explore functionality.
 */
export const createExploreImageV1ExploreImagesPostMutation = (
  options?: Partial<Options<CreateExploreImageV1ExploreImagesPostData>>,
): UseMutationOptions<
  CreateExploreImageV1ExploreImagesPostResponse,
  CreateExploreImageV1ExploreImagesPostError,
  Options<CreateExploreImageV1ExploreImagesPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateExploreImageV1ExploreImagesPostResponse,
    CreateExploreImageV1ExploreImagesPostError,
    Options<CreateExploreImageV1ExploreImagesPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createExploreImageV1ExploreImagesPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Explore Image
 *
 * Delete an ExploreImage record.
 */
export const deleteExploreImageV1ExploreImagesExploreImageIdDeleteMutation = (
  options?: Partial<Options<DeleteExploreImageV1ExploreImagesExploreImageIdDeleteData>>,
): UseMutationOptions<
  DeleteExploreImageV1ExploreImagesExploreImageIdDeleteResponse,
  DeleteExploreImageV1ExploreImagesExploreImageIdDeleteError,
  Options<DeleteExploreImageV1ExploreImagesExploreImageIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteExploreImageV1ExploreImagesExploreImageIdDeleteResponse,
    DeleteExploreImageV1ExploreImagesExploreImageIdDeleteError,
    Options<DeleteExploreImageV1ExploreImagesExploreImageIdDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteExploreImageV1ExploreImagesExploreImageIdDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getExploreImageV1ExploreImagesExploreImageIdGetQueryKey = (
  options: Options<GetExploreImageV1ExploreImagesExploreImageIdGetData>,
) => createQueryKey('getExploreImageV1ExploreImagesExploreImageIdGet', options);

/**
 * Get Explore Image
 *
 * Get a specific ExploreImage record by ID.
 */
export const getExploreImageV1ExploreImagesExploreImageIdGetOptions = (
  options: Options<GetExploreImageV1ExploreImagesExploreImageIdGetData>,
) =>
  queryOptions<
    GetExploreImageV1ExploreImagesExploreImageIdGetResponse,
    GetExploreImageV1ExploreImagesExploreImageIdGetError,
    GetExploreImageV1ExploreImagesExploreImageIdGetResponse,
    ReturnType<typeof getExploreImageV1ExploreImagesExploreImageIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExploreImageV1ExploreImagesExploreImageIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getExploreImageV1ExploreImagesExploreImageIdGetQueryKey(options),
  });

/**
 * Replace Explore Image
 *
 * Replace an ExploreImage record completely (all fields required).
 */
export const replaceExploreImageV1ExploreImagesExploreImageIdPutMutation = (
  options?: Partial<Options<ReplaceExploreImageV1ExploreImagesExploreImageIdPutData>>,
): UseMutationOptions<
  ReplaceExploreImageV1ExploreImagesExploreImageIdPutResponse,
  ReplaceExploreImageV1ExploreImagesExploreImageIdPutError,
  Options<ReplaceExploreImageV1ExploreImagesExploreImageIdPutData>
> => {
  const mutationOptions: UseMutationOptions<
    ReplaceExploreImageV1ExploreImagesExploreImageIdPutResponse,
    ReplaceExploreImageV1ExploreImagesExploreImageIdPutError,
    Options<ReplaceExploreImageV1ExploreImagesExploreImageIdPutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await replaceExploreImageV1ExploreImagesExploreImageIdPut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Explore Pdp
 *
 * Create a new ExplorePDP record for explore functionality.
 */
export const createExplorePdpV1ExplorePdpsPostMutation = (
  options?: Partial<Options<CreateExplorePdpV1ExplorePdpsPostData>>,
): UseMutationOptions<
  CreateExplorePdpV1ExplorePdpsPostResponse,
  CreateExplorePdpV1ExplorePdpsPostError,
  Options<CreateExplorePdpV1ExplorePdpsPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateExplorePdpV1ExplorePdpsPostResponse,
    CreateExplorePdpV1ExplorePdpsPostError,
    Options<CreateExplorePdpV1ExplorePdpsPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createExplorePdpV1ExplorePdpsPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getExplorePdpV1ExplorePdpsExplorePdpIdGetQueryKey = (
  options: Options<GetExplorePdpV1ExplorePdpsExplorePdpIdGetData>,
) => createQueryKey('getExplorePdpV1ExplorePdpsExplorePdpIdGet', options);

/**
 * Get Explore Pdp
 *
 * Get a specific ExplorePDP record by ID.
 */
export const getExplorePdpV1ExplorePdpsExplorePdpIdGetOptions = (
  options: Options<GetExplorePdpV1ExplorePdpsExplorePdpIdGetData>,
) =>
  queryOptions<
    GetExplorePdpV1ExplorePdpsExplorePdpIdGetResponse,
    GetExplorePdpV1ExplorePdpsExplorePdpIdGetError,
    GetExplorePdpV1ExplorePdpsExplorePdpIdGetResponse,
    ReturnType<typeof getExplorePdpV1ExplorePdpsExplorePdpIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getExplorePdpV1ExplorePdpsExplorePdpIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getExplorePdpV1ExplorePdpsExplorePdpIdGetQueryKey(options),
  });

/**
 * Update Explore Pdp
 *
 * Update an ExplorePDP record with partial data.
 */
export const updateExplorePdpV1ExplorePdpsExplorePdpIdPatchMutation = (
  options?: Partial<Options<UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchData>>,
): UseMutationOptions<
  UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchResponse,
  UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchError,
  Options<UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchResponse,
    UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchError,
    Options<UpdateExplorePdpV1ExplorePdpsExplorePdpIdPatchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateExplorePdpV1ExplorePdpsExplorePdpIdPatch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetQueryKey = (
  options: Options<GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetData>,
) => createQueryKey('getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGet', options);

/**
 * Get Classification Feedback
 *
 * Get the user's ClassificationFeedback record for a specific ExploreImage.
 */
export const getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetOptions = (
  options: Options<GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetData>,
) =>
  queryOptions<
    GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetResponse,
    GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetError,
    GetClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetResponse,
    ReturnType<typeof getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackGetQueryKey(options),
  });

/**
 * Create Classification Feedback
 *
 * Create a new ClassificationFeedback record for an ExploreImage.
 */
export const createClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostMutation = (
  options?: Partial<Options<CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostData>>,
): UseMutationOptions<
  CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostResponse,
  CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostError,
  Options<CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostResponse,
    CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostError,
    Options<CreateClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createClassificationFeedbackV1ExploreImagesExploreImageIdFeedbackPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getImageClassificationV1ExploreClassificationsClassificationIdGetQueryKey = (
  options: Options<GetImageClassificationV1ExploreClassificationsClassificationIdGetData>,
) => createQueryKey('getImageClassificationV1ExploreClassificationsClassificationIdGet', options);

/**
 * Get Image Classification
 *
 * Get a specific ImageClassification record by ID.
 */
export const getImageClassificationV1ExploreClassificationsClassificationIdGetOptions = (
  options: Options<GetImageClassificationV1ExploreClassificationsClassificationIdGetData>,
) =>
  queryOptions<
    GetImageClassificationV1ExploreClassificationsClassificationIdGetResponse,
    GetImageClassificationV1ExploreClassificationsClassificationIdGetError,
    GetImageClassificationV1ExploreClassificationsClassificationIdGetResponse,
    ReturnType<typeof getImageClassificationV1ExploreClassificationsClassificationIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getImageClassificationV1ExploreClassificationsClassificationIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getImageClassificationV1ExploreClassificationsClassificationIdGetQueryKey(options),
  });

export const listImageClassificationsV1ExploreClassificationsGetQueryKey = (
  options?: Options<ListImageClassificationsV1ExploreClassificationsGetData>,
) => createQueryKey('listImageClassificationsV1ExploreClassificationsGet', options);

/**
 * List Image Classifications
 *
 * Get a list of all ImageClassification records.
 */
export const listImageClassificationsV1ExploreClassificationsGetOptions = (
  options?: Options<ListImageClassificationsV1ExploreClassificationsGetData>,
) =>
  queryOptions<
    ListImageClassificationsV1ExploreClassificationsGetResponse,
    DefaultError,
    ListImageClassificationsV1ExploreClassificationsGetResponse,
    ReturnType<typeof listImageClassificationsV1ExploreClassificationsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listImageClassificationsV1ExploreClassificationsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listImageClassificationsV1ExploreClassificationsGetQueryKey(options),
  });

export const listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetQueryKey = (
  options: Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>,
) => createQueryKey('listClassificationImagesV1ExploreClassificationsClassificationIdImagesGet', options);

/**
 * List Classification Images
 *
 * Get a paginated list of ExploreImage records with the given classification ID.
 *
 * Filters:
 * - product_category_id: Filter by product category
 * - query_id: Filter by query
 * - min_score: Minimum vizit_score (inclusive, default: 80)
 * - max_score: Maximum vizit_score (inclusive)
 *
 * Sorting:
 * - sort: "asc" or "desc" (default: "desc") - sorts by vizit_score
 *
 * Deduplication:
 * - Results are deduplicated by (name, brand, score_clip/score_effnet)
 * - Uses ROW_NUMBER() PARTITION BY ei.name, ei.brand, ei.score_*
 * - Keeps the first row (rn = 1) per (name, brand, score) pair
 * - Note: vizit_score may differ across variant images in the same group
 * - Pagination and total count reflect deduplicated results
 */
export const listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetOptions = (
  options: Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>,
) =>
  queryOptions<
    ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetResponse,
    ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetError,
    ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetResponse,
    ReturnType<typeof listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listClassificationImagesV1ExploreClassificationsClassificationIdImagesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetQueryKey(options),
  });

export const listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetInfiniteQueryKey = (
  options: Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>,
): QueryKey<Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>> =>
  createQueryKey('listClassificationImagesV1ExploreClassificationsClassificationIdImagesGet', options, true);

/**
 * List Classification Images
 *
 * Get a paginated list of ExploreImage records with the given classification ID.
 *
 * Filters:
 * - product_category_id: Filter by product category
 * - query_id: Filter by query
 * - min_score: Minimum vizit_score (inclusive, default: 80)
 * - max_score: Maximum vizit_score (inclusive)
 *
 * Sorting:
 * - sort: "asc" or "desc" (default: "desc") - sorts by vizit_score
 *
 * Deduplication:
 * - Results are deduplicated by (name, brand, score_clip/score_effnet)
 * - Uses ROW_NUMBER() PARTITION BY ei.name, ei.brand, ei.score_*
 * - Keeps the first row (rn = 1) per (name, brand, score) pair
 * - Note: vizit_score may differ across variant images in the same group
 * - Pagination and total count reflect deduplicated results
 */
export const listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetInfiniteOptions = (
  options: Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>,
) =>
  infiniteQueryOptions<
    ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetResponse,
    ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetError,
    InfiniteData<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetResponse>,
    QueryKey<Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>>,
    | number
    | Pick<
        QueryKey<Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListClassificationImagesV1ExploreClassificationsClassificationIdImagesGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await listClassificationImagesV1ExploreClassificationsClassificationIdImagesGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: listClassificationImagesV1ExploreClassificationsClassificationIdImagesGetInfiniteQueryKey(options),
    },
  );

/**
 * Create Query
 *
 * Create a new Query record for explore functionality.
 */
export const createQueryV1ExploreQueriesPostMutation = (
  options?: Partial<Options<CreateQueryV1ExploreQueriesPostData>>,
): UseMutationOptions<
  CreateQueryV1ExploreQueriesPostResponse,
  CreateQueryV1ExploreQueriesPostError,
  Options<CreateQueryV1ExploreQueriesPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateQueryV1ExploreQueriesPostResponse,
    CreateQueryV1ExploreQueriesPostError,
    Options<CreateQueryV1ExploreQueriesPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createQueryV1ExploreQueriesPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getQueryV1ExploreQueriesQueryIdGetQueryKey = (options: Options<GetQueryV1ExploreQueriesQueryIdGetData>) =>
  createQueryKey('getQueryV1ExploreQueriesQueryIdGet', options);

/**
 * Get Query
 *
 * Get a specific Query record by ID.
 */
export const getQueryV1ExploreQueriesQueryIdGetOptions = (options: Options<GetQueryV1ExploreQueriesQueryIdGetData>) =>
  queryOptions<
    GetQueryV1ExploreQueriesQueryIdGetResponse,
    GetQueryV1ExploreQueriesQueryIdGetError,
    GetQueryV1ExploreQueriesQueryIdGetResponse,
    ReturnType<typeof getQueryV1ExploreQueriesQueryIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getQueryV1ExploreQueriesQueryIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getQueryV1ExploreQueriesQueryIdGetQueryKey(options),
  });

/**
 * Update Query
 *
 * Update a Query record with partial data.
 */
export const updateQueryV1ExploreQueriesQueryIdPatchMutation = (
  options?: Partial<Options<UpdateQueryV1ExploreQueriesQueryIdPatchData>>,
): UseMutationOptions<
  UpdateQueryV1ExploreQueriesQueryIdPatchResponse,
  UpdateQueryV1ExploreQueriesQueryIdPatchError,
  Options<UpdateQueryV1ExploreQueriesQueryIdPatchData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateQueryV1ExploreQueriesQueryIdPatchResponse,
    UpdateQueryV1ExploreQueriesQueryIdPatchError,
    Options<UpdateQueryV1ExploreQueriesQueryIdPatchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateQueryV1ExploreQueriesQueryIdPatch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const listFeatureFlagsV1FeatureFlagsGetQueryKey = (options?: Options<ListFeatureFlagsV1FeatureFlagsGetData>) =>
  createQueryKey('listFeatureFlagsV1FeatureFlagsGet', options);

/**
 * List Feature Flags
 *
 * Evaluate all BE feature flags for the current authenticated user.
 */
export const listFeatureFlagsV1FeatureFlagsGetOptions = (options?: Options<ListFeatureFlagsV1FeatureFlagsGetData>) =>
  queryOptions<
    ListFeatureFlagsV1FeatureFlagsGetResponse,
    DefaultError,
    ListFeatureFlagsV1FeatureFlagsGetResponse,
    ReturnType<typeof listFeatureFlagsV1FeatureFlagsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listFeatureFlagsV1FeatureFlagsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listFeatureFlagsV1FeatureFlagsGetQueryKey(options),
  });

export const getFeatureFlagV1FeatureFlagsFlagGetQueryKey = (
  options: Options<GetFeatureFlagV1FeatureFlagsFlagGetData>,
) => createQueryKey('getFeatureFlagV1FeatureFlagsFlagGet', options);

/**
 * Get Feature Flag
 *
 * Evaluate a single feature flag for the current authenticated user.
 */
export const getFeatureFlagV1FeatureFlagsFlagGetOptions = (options: Options<GetFeatureFlagV1FeatureFlagsFlagGetData>) =>
  queryOptions<
    GetFeatureFlagV1FeatureFlagsFlagGetResponse,
    GetFeatureFlagV1FeatureFlagsFlagGetError,
    GetFeatureFlagV1FeatureFlagsFlagGetResponse,
    ReturnType<typeof getFeatureFlagV1FeatureFlagsFlagGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getFeatureFlagV1FeatureFlagsFlagGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getFeatureFlagV1FeatureFlagsFlagGetQueryKey(options),
  });

export const searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetQueryKey = (
  options: Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>,
) => createQueryKey('searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGet', options);

/**
 * Search Ideas
 */
export const searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetOptions = (
  options: Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>,
) =>
  queryOptions<
    SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetResponse,
    SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetError,
    SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetResponse,
    ReturnType<typeof searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetQueryKey(options),
  });

export const searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetInfiniteQueryKey = (
  options: Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>,
): QueryKey<Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>> =>
  createQueryKey('searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGet', options, true);

/**
 * Search Ideas
 */
export const searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetInfiniteOptions = (
  options: Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>,
) =>
  infiniteQueryOptions<
    SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetResponse,
    SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetError,
    InfiniteData<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetResponse>,
    QueryKey<Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>>,
    | number
    | Pick<
        QueryKey<Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SearchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: searchIdeasV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasGetInfiniteQueryKey(options),
    },
  );

/**
 * Create Idea
 */
export const createIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostMutation = (
  options?: Partial<Options<CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostData>>,
): UseMutationOptions<
  CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostResponse,
  CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostError,
  Options<CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostResponse,
    CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostError,
    Options<CreateIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetQueryKey = (
  options: Options<GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetData>,
) => createQueryKey('getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGet', options);

/**
 * Get Idea
 */
export const getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetOptions = (
  options: Options<GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetData>,
) =>
  queryOptions<
    GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetResponse,
    GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetError,
    GetIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetResponse,
    ReturnType<typeof getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getIdeaV1PortfoliosPortfolioIdAssetsImagesImageIdIdeasIdeaIdGetQueryKey(options),
  });

export const searchImagesV1PortfoliosPortfolioIdAssetsImagesGetQueryKey = (
  options: Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>,
) => createQueryKey('searchImagesV1PortfoliosPortfolioIdAssetsImagesGet', options);

/**
 * Search Images
 *
 * Retrieves images for a portfolio with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID(s) to find children (multi-select)
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 * - product_category_id: Filter by product category ID(s)
 * - image_type: Filter by image type (hero or carousel)
 */
export const searchImagesV1PortfoliosPortfolioIdAssetsImagesGetOptions = (
  options: Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>,
) =>
  queryOptions<
    SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetResponse,
    SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetError,
    SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetResponse,
    ReturnType<typeof searchImagesV1PortfoliosPortfolioIdAssetsImagesGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchImagesV1PortfoliosPortfolioIdAssetsImagesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: searchImagesV1PortfoliosPortfolioIdAssetsImagesGetQueryKey(options),
  });

export const searchImagesV1PortfoliosPortfolioIdAssetsImagesGetInfiniteQueryKey = (
  options: Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>,
): QueryKey<Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>> =>
  createQueryKey('searchImagesV1PortfoliosPortfolioIdAssetsImagesGet', options, true);

/**
 * Search Images
 *
 * Retrieves images for a portfolio with pagination and filtering support.
 *
 * Filters:
 * - parent_id: Filter by parent image ID(s) to find children (multi-select)
 * - source: Include only images with these source types
 * - exclude_source: Exclude images with these source types
 * - image_ids: Filter by specific image IDs
 * - product_category_id: Filter by product category ID(s)
 * - image_type: Filter by image type (hero or carousel)
 */
export const searchImagesV1PortfoliosPortfolioIdAssetsImagesGetInfiniteOptions = (
  options: Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>,
) =>
  infiniteQueryOptions<
    SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetResponse,
    SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetError,
    InfiniteData<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetResponse>,
    QueryKey<Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>>,
    | number
    | Pick<
        QueryKey<Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SearchImagesV1PortfoliosPortfolioIdAssetsImagesGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchImagesV1PortfoliosPortfolioIdAssetsImagesGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: searchImagesV1PortfoliosPortfolioIdAssetsImagesGetInfiniteQueryKey(options),
    },
  );

/**
 * Upload Image
 *
 * Uploads image metadata and returns the Image model
 */
export const uploadImageV1PortfoliosPortfolioIdAssetsImagesPostMutation = (
  options?: Partial<Options<UploadImageV1PortfoliosPortfolioIdAssetsImagesPostData>>,
): UseMutationOptions<
  UploadImageV1PortfoliosPortfolioIdAssetsImagesPostResponse,
  UploadImageV1PortfoliosPortfolioIdAssetsImagesPostError,
  Options<UploadImageV1PortfoliosPortfolioIdAssetsImagesPostData>
> => {
  const mutationOptions: UseMutationOptions<
    UploadImageV1PortfoliosPortfolioIdAssetsImagesPostResponse,
    UploadImageV1PortfoliosPortfolioIdAssetsImagesPostError,
    Options<UploadImageV1PortfoliosPortfolioIdAssetsImagesPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await uploadImageV1PortfoliosPortfolioIdAssetsImagesPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Image
 *
 * Delete a portfolio image.
 */
export const deleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteMutation = (
  options?: Partial<Options<DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteData>>,
): UseMutationOptions<
  DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteResponse,
  DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteError,
  Options<DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteResponse,
    DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteError,
    Options<DeleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteImageV1PortfoliosPortfolioIdAssetsImagesImageIdDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetQueryKey = (
  options: Options<GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetData>,
) => createQueryKey('getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGet', options);

/**
 * Get Image
 *
 * returns an Image by ID
 */
export const getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetOptions = (
  options: Options<GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetData>,
) =>
  queryOptions<
    GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetResponse,
    GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetError,
    GetImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetResponse,
    ReturnType<typeof getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getImageV1PortfoliosPortfolioIdAssetsImagesImageIdGetQueryKey(options),
  });

/**
 * Create Image Score
 *
 * Internal endpoint called by Lambda. Returns minimal dict response instead of
 * ImageView to avoid unnecessary S3 signed URL generation and eager loading —
 * Lambda callers only check the status code.
 */
export const createImageScoreV1AssetsImagesImageIdRawScorePostMutation = (
  options?: Partial<Options<CreateImageScoreV1AssetsImagesImageIdRawScorePostData>>,
): UseMutationOptions<
  CreateImageScoreV1AssetsImagesImageIdRawScorePostResponse,
  CreateImageScoreV1AssetsImagesImageIdRawScorePostError,
  Options<CreateImageScoreV1AssetsImagesImageIdRawScorePostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateImageScoreV1AssetsImagesImageIdRawScorePostResponse,
    CreateImageScoreV1AssetsImagesImageIdRawScorePostError,
    Options<CreateImageScoreV1AssetsImagesImageIdRawScorePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createImageScoreV1AssetsImagesImageIdRawScorePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Image Classification
 *
 * Internal endpoint called by Lambda. Returns minimal dict response instead of
 * ImageView to avoid unnecessary S3 signed URL generation and eager loading —
 * Lambda callers only check the status code.
 */
export const createImageClassificationV1AssetsImagesImageIdClassificationPostMutation = (
  options?: Partial<Options<CreateImageClassificationV1AssetsImagesImageIdClassificationPostData>>,
): UseMutationOptions<
  CreateImageClassificationV1AssetsImagesImageIdClassificationPostResponse,
  CreateImageClassificationV1AssetsImagesImageIdClassificationPostError,
  Options<CreateImageClassificationV1AssetsImagesImageIdClassificationPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateImageClassificationV1AssetsImagesImageIdClassificationPostResponse,
    CreateImageClassificationV1AssetsImagesImageIdClassificationPostError,
    Options<CreateImageClassificationV1AssetsImagesImageIdClassificationPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createImageClassificationV1AssetsImagesImageIdClassificationPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Batch Update Image Classifications
 *
 * Internal endpoint called by Lambda. Updates classifications for multiple
 * images in a single request. Returns minimal dict response — Lambda callers
 * only check the status code.
 */
export const batchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostMutation = (
  options?: Partial<Options<BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostData>>,
): UseMutationOptions<
  BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostResponse,
  BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostError,
  Options<BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostData>
> => {
  const mutationOptions: UseMutationOptions<
    BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostResponse,
    BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostError,
    Options<BatchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await batchUpdateImageClassificationsV1AssetsImagesClassificationsBatchPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Exclusion Prediction
 *
 * Internal endpoint called by Lambda. Returns minimal dict response instead of
 * ImageView to avoid unnecessary S3 signed URL generation and eager loading —
 * Lambda callers only check the status code.
 */
export const createExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostMutation = (
  options?: Partial<Options<CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostData>>,
): UseMutationOptions<
  CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostResponse,
  CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostError,
  Options<CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostResponse,
    CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostError,
    Options<CreateExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createExclusionPredictionV1AssetsImagesImageIdExclusionPredictionPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetQueryKey = (
  options: Options<GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetData>,
) => createQueryKey('getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGet', options);

/**
 * Get Image Count
 */
export const getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetOptions = (
  options: Options<GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetData>,
) =>
  queryOptions<
    GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetResponse,
    GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetError,
    GetImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetResponse,
    ReturnType<typeof getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getImageCountV1PortfoliosPortfolioIdPdpsPdpIdImageCountGetQueryKey(options),
  });

/**
 * Generate Prompts For Image
 *
 * Create 7 ImageGenPrompts records for an image and trigger parallel processing.
 */
export const generatePromptsForImageV1ImagesImageIdGeneratePromptsPostMutation = (
  options?: Partial<Options<GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostData>>,
): UseMutationOptions<
  GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostResponse,
  GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostError,
  Options<GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostData>
> => {
  const mutationOptions: UseMutationOptions<
    GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostResponse,
    GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostError,
    Options<GeneratePromptsForImageV1ImagesImageIdGeneratePromptsPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await generatePromptsForImageV1ImagesImageIdGeneratePromptsPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetQueryKey = (
  options: Options<GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetData>,
) => createQueryKey('getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGet', options);

/**
 * Get Batch Status
 *
 * Get the status of a batch of ImageGenPrompts records for a specific image.
 */
export const getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetOptions = (
  options: Options<GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetData>,
) =>
  queryOptions<
    GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetResponse,
    GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetError,
    GetBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetResponse,
    ReturnType<typeof getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getBatchStatusV1ImagesImageIdGeneratePromptsBatchIdGetQueryKey(options),
  });

/**
 * Delete Image Gen Prompt
 *
 * Delete an ImageGenPrompts record.
 */
export const deleteImageGenPromptV1ImageGenPromptsPromptIdDeleteMutation = (
  options?: Partial<Options<DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteData>>,
): UseMutationOptions<
  DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteResponse,
  DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteError,
  Options<DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteResponse,
    DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteError,
    Options<DeleteImageGenPromptV1ImageGenPromptsPromptIdDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteImageGenPromptV1ImageGenPromptsPromptIdDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getImageGenPromptV1ImageGenPromptsPromptIdGetQueryKey = (
  options: Options<GetImageGenPromptV1ImageGenPromptsPromptIdGetData>,
) => createQueryKey('getImageGenPromptV1ImageGenPromptsPromptIdGet', options);

/**
 * Get Image Gen Prompt
 *
 * Get a specific ImageGenPrompts record by ID.
 */
export const getImageGenPromptV1ImageGenPromptsPromptIdGetOptions = (
  options: Options<GetImageGenPromptV1ImageGenPromptsPromptIdGetData>,
) =>
  queryOptions<
    GetImageGenPromptV1ImageGenPromptsPromptIdGetResponse,
    GetImageGenPromptV1ImageGenPromptsPromptIdGetError,
    GetImageGenPromptV1ImageGenPromptsPromptIdGetResponse,
    ReturnType<typeof getImageGenPromptV1ImageGenPromptsPromptIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getImageGenPromptV1ImageGenPromptsPromptIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getImageGenPromptV1ImageGenPromptsPromptIdGetQueryKey(options),
  });

/**
 * Update Image Gen Prompt
 *
 * Update an ImageGenPrompts record status and/or output.
 */
export const updateImageGenPromptV1ImageGenPromptsPromptIdPatchMutation = (
  options?: Partial<Options<UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchData>>,
): UseMutationOptions<
  unknown,
  UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchError,
  Options<UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchError,
    Options<UpdateImageGenPromptV1ImageGenPromptsPromptIdPatchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateImageGenPromptV1ImageGenPromptsPromptIdPatch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getImageByIdV1ImagesImageIdGetQueryKey = (options: Options<GetImageByIdV1ImagesImageIdGetData>) =>
  createQueryKey('getImageByIdV1ImagesImageIdGet', options);

/**
 * Get Image By Id
 *
 * Get a specific Image record by ID (for Lambda function use).
 */
export const getImageByIdV1ImagesImageIdGetOptions = (options: Options<GetImageByIdV1ImagesImageIdGetData>) =>
  queryOptions<
    GetImageByIdV1ImagesImageIdGetResponse,
    GetImageByIdV1ImagesImageIdGetError,
    GetImageByIdV1ImagesImageIdGetResponse,
    ReturnType<typeof getImageByIdV1ImagesImageIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getImageByIdV1ImagesImageIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getImageByIdV1ImagesImageIdGetQueryKey(options),
  });

export const getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetQueryKey = (
  options: Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>,
) => createQueryKey('getImageGenPromptsForImageV1ImagesImageIdGenPromptsGet', options);

/**
 * Get Image Gen Prompts For Image
 *
 * Get all ImageGenPrompts records for a specific image.
 */
export const getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetOptions = (
  options: Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>,
) =>
  queryOptions<
    GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetResponse,
    GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetError,
    GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetResponse,
    ReturnType<typeof getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getImageGenPromptsForImageV1ImagesImageIdGenPromptsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetQueryKey(options),
  });

export const getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetInfiniteQueryKey = (
  options: Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>,
): QueryKey<Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>> =>
  createQueryKey('getImageGenPromptsForImageV1ImagesImageIdGenPromptsGet', options, true);

/**
 * Get Image Gen Prompts For Image
 *
 * Get all ImageGenPrompts records for a specific image.
 */
export const getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetInfiniteOptions = (
  options: Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>,
) =>
  infiniteQueryOptions<
    GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetResponse,
    GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetError,
    InfiniteData<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetResponse>,
    QueryKey<Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>>,
    | number
    | Pick<
        QueryKey<Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetImageGenPromptsForImageV1ImagesImageIdGenPromptsGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getImageGenPromptsForImageV1ImagesImageIdGenPromptsGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getImageGenPromptsForImageV1ImagesImageIdGenPromptsGetInfiniteQueryKey(options),
    },
  );

export const getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetQueryKey = (
  options: Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>,
) => createQueryKey('getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGet', options);

/**
 * Get Image Gen Prompts For Category
 *
 * Get all ImageGenPrompts records for a specific product category, optionally filtered by status.
 */
export const getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetOptions = (
  options: Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>,
) =>
  queryOptions<
    GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetResponse,
    GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetError,
    GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetResponse,
    ReturnType<typeof getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetQueryKey(options),
  });

export const getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetInfiniteQueryKey = (
  options: Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>,
): QueryKey<Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>> =>
  createQueryKey('getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGet', options, true);

/**
 * Get Image Gen Prompts For Category
 *
 * Get all ImageGenPrompts records for a specific product category, optionally filtered by status.
 */
export const getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetInfiniteOptions = (
  options: Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>,
) =>
  infiniteQueryOptions<
    GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetResponse,
    GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetError,
    InfiniteData<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetResponse>,
    QueryKey<Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>>,
    | number
    | Pick<
        QueryKey<Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getImageGenPromptsForCategoryV1ProductCategoriesCategoryIdGenPromptsGetInfiniteQueryKey(options),
    },
  );

export const getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetQueryKey = (
  options: Options<GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetData>,
) => createQueryKey('getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGet', options);

/**
 * Get Image Order
 */
export const getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetOptions = (
  options: Options<GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetData>,
) =>
  queryOptions<
    GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetResponse,
    GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetError,
    GetImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetResponse,
    ReturnType<typeof getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getImageOrderV1PortfoliosPortfolioIdPdpsPdpIdImageOrderGetQueryKey(options),
  });

export const getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetQueryKey = (
  options: Options<GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetData>,
) => createQueryKey('getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGet', options);

/**
 * Get Image Mix
 */
export const getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetOptions = (
  options: Options<GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetData>,
) =>
  queryOptions<
    GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetResponse,
    GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetError,
    GetImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetResponse,
    ReturnType<typeof getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getImageMixV1PortfoliosPortfolioIdPdpsPdpIdImageMixGetQueryKey(options),
  });

export const getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetQueryKey = (
  options: Options<GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetData>,
) => createQueryKey('getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGet', options);

/**
 * Get Image Scores
 */
export const getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetOptions = (
  options: Options<GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetData>,
) =>
  queryOptions<
    GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetResponse,
    GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetError,
    GetImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetResponse,
    ReturnType<typeof getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getImageScoresV1PortfoliosPortfolioIdPdpsPdpIdImageScoresGetQueryKey(options),
  });

/**
 * Create Organization
 */
export const createOrganizationV1OrganizationsPostMutation = (
  options?: Partial<Options<CreateOrganizationV1OrganizationsPostData>>,
): UseMutationOptions<
  CreateOrganizationV1OrganizationsPostResponse,
  CreateOrganizationV1OrganizationsPostError,
  Options<CreateOrganizationV1OrganizationsPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateOrganizationV1OrganizationsPostResponse,
    CreateOrganizationV1OrganizationsPostError,
    Options<CreateOrganizationV1OrganizationsPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createOrganizationV1OrganizationsPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Organization Icp Product Category
 */
export const deleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteMutation =
  (
    options?: Partial<
      Options<DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteData>
    >,
  ): UseMutationOptions<
    DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteResponse,
    DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteError,
    Options<DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteData>
  > => {
    const mutationOptions: UseMutationOptions<
      DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteResponse,
      DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteError,
      Options<DeleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDeleteData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await deleteOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdDelete({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Create Organization Icp Product Category
 *
 * Creates an ICP product category linked to an organization, returns the ICP product category
 */
export const createOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostMutation =
  (
    options?: Partial<
      Options<CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostData>
    >,
  ): UseMutationOptions<
    CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostResponse,
    CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostError,
    Options<CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostData>
  > => {
    const mutationOptions: UseMutationOptions<
      CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostResponse,
      CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostError,
      Options<CreateOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPostData>
    > = {
      mutationFn: async (fnOptions) => {
        const { data } =
          await createOrganizationIcpProductCategoryV1OrganizationsOrgIdProductCategoriesIcpProductCategoryIdPost({
            ...options,
            ...fnOptions,
            throwOnError: true,
          });
        return data;
      },
    };
    return mutationOptions;
  };

/**
 * Remove Retailer Region From Organization
 *
 * Unlink a retailer region from an organization.
 */
export const removeRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteMutation = (
  options?: Partial<
    Options<RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteData>
  >,
): UseMutationOptions<
  RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteResponse,
  RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteError,
  Options<RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteResponse,
    RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteError,
    Options<RemoveRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } =
        await removeRetailerRegionFromOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdDelete({
          ...options,
          ...fnOptions,
          throwOnError: true,
        });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Add Retailer Region To Organization
 *
 * Link a retailer region to an organization.
 */
export const addRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostMutation = (
  options?: Partial<
    Options<AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostData>
  >,
): UseMutationOptions<
  AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostResponse,
  AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostError,
  Options<AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostData>
> => {
  const mutationOptions: UseMutationOptions<
    AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostResponse,
    AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostError,
    Options<AddRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addRetailerRegionToOrganizationV1OrganizationsOrgIdRetailerRegionsRetailerRegionIdPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrganizationV1OrganizationsOrgIdGetQueryKey = (
  options: Options<GetOrganizationV1OrganizationsOrgIdGetData>,
) => createQueryKey('getOrganizationV1OrganizationsOrgIdGet', options);

/**
 * Get Organization
 */
export const getOrganizationV1OrganizationsOrgIdGetOptions = (
  options: Options<GetOrganizationV1OrganizationsOrgIdGetData>,
) =>
  queryOptions<
    GetOrganizationV1OrganizationsOrgIdGetResponse,
    GetOrganizationV1OrganizationsOrgIdGetError,
    GetOrganizationV1OrganizationsOrgIdGetResponse,
    ReturnType<typeof getOrganizationV1OrganizationsOrgIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationV1OrganizationsOrgIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrganizationV1OrganizationsOrgIdGetQueryKey(options),
  });

/**
 * Update Organization
 */
export const updateOrganizationV1OrganizationsOrgIdPutMutation = (
  options?: Partial<Options<UpdateOrganizationV1OrganizationsOrgIdPutData>>,
): UseMutationOptions<
  UpdateOrganizationV1OrganizationsOrgIdPutResponse,
  UpdateOrganizationV1OrganizationsOrgIdPutError,
  Options<UpdateOrganizationV1OrganizationsOrgIdPutData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateOrganizationV1OrganizationsOrgIdPutResponse,
    UpdateOrganizationV1OrganizationsOrgIdPutError,
    Options<UpdateOrganizationV1OrganizationsOrgIdPutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateOrganizationV1OrganizationsOrgIdPut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getRetailersForOrganizationV1OrganizationsOrgIdRetailersGetQueryKey = (
  options: Options<GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetData>,
) => createQueryKey('getRetailersForOrganizationV1OrganizationsOrgIdRetailersGet', options);

/**
 * Get Retailers For Organization
 *
 * List distinct retailer regions available to an organization.
 */
export const getRetailersForOrganizationV1OrganizationsOrgIdRetailersGetOptions = (
  options: Options<GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetData>,
) =>
  queryOptions<
    GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetResponse,
    GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetError,
    GetRetailersForOrganizationV1OrganizationsOrgIdRetailersGetResponse,
    ReturnType<typeof getRetailersForOrganizationV1OrganizationsOrgIdRetailersGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRetailersForOrganizationV1OrganizationsOrgIdRetailersGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRetailersForOrganizationV1OrganizationsOrgIdRetailersGetQueryKey(options),
  });

export const getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetQueryKey = (
  options: Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>,
) => createQueryKey('getUsersForOrganizationV1OrganizationsOrganizationIdUsersGet', options);

/**
 * Get Users For Organization
 */
export const getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetOptions = (
  options: Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>,
) =>
  queryOptions<
    GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetResponse,
    GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetError,
    GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetResponse,
    ReturnType<typeof getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUsersForOrganizationV1OrganizationsOrganizationIdUsersGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetQueryKey(options),
  });

export const getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetInfiniteQueryKey = (
  options: Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>,
): QueryKey<Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>> =>
  createQueryKey('getUsersForOrganizationV1OrganizationsOrganizationIdUsersGet', options, true);

/**
 * Get Users For Organization
 */
export const getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetInfiniteOptions = (
  options: Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>,
) =>
  infiniteQueryOptions<
    GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetResponse,
    GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetError,
    InfiniteData<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetResponse>,
    QueryKey<Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>>,
    | number
    | null
    | Pick<
        QueryKey<Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetUsersForOrganizationV1OrganizationsOrganizationIdUsersGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getUsersForOrganizationV1OrganizationsOrganizationIdUsersGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getUsersForOrganizationV1OrganizationsOrganizationIdUsersGetInfiniteQueryKey(options),
    },
  );

export const searchPdpsV1PortfoliosPortfolioIdPdpsGetQueryKey = (
  options: Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>,
) => createQueryKey('searchPdpsV1PortfoliosPortfolioIdPdpsGet', options);

/**
 * Search Pdps
 */
export const searchPdpsV1PortfoliosPortfolioIdPdpsGetOptions = (
  options: Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>,
) =>
  queryOptions<
    SearchPdpsV1PortfoliosPortfolioIdPdpsGetResponse,
    SearchPdpsV1PortfoliosPortfolioIdPdpsGetError,
    SearchPdpsV1PortfoliosPortfolioIdPdpsGetResponse,
    ReturnType<typeof searchPdpsV1PortfoliosPortfolioIdPdpsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchPdpsV1PortfoliosPortfolioIdPdpsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: searchPdpsV1PortfoliosPortfolioIdPdpsGetQueryKey(options),
  });

export const searchPdpsV1PortfoliosPortfolioIdPdpsGetInfiniteQueryKey = (
  options: Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>,
): QueryKey<Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>> =>
  createQueryKey('searchPdpsV1PortfoliosPortfolioIdPdpsGet', options, true);

/**
 * Search Pdps
 */
export const searchPdpsV1PortfoliosPortfolioIdPdpsGetInfiniteOptions = (
  options: Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>,
) =>
  infiniteQueryOptions<
    SearchPdpsV1PortfoliosPortfolioIdPdpsGetResponse,
    SearchPdpsV1PortfoliosPortfolioIdPdpsGetError,
    InfiniteData<SearchPdpsV1PortfoliosPortfolioIdPdpsGetResponse>,
    QueryKey<Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>>,
    | number
    | Pick<QueryKey<Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SearchPdpsV1PortfoliosPortfolioIdPdpsGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchPdpsV1PortfoliosPortfolioIdPdpsGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: searchPdpsV1PortfoliosPortfolioIdPdpsGetInfiniteQueryKey(options),
    },
  );

/**
 * Create Pdp
 */
export const createPdpV1PortfoliosPortfolioIdPdpsPostMutation = (
  options?: Partial<Options<CreatePdpV1PortfoliosPortfolioIdPdpsPostData>>,
): UseMutationOptions<
  CreatePdpV1PortfoliosPortfolioIdPdpsPostResponse,
  CreatePdpV1PortfoliosPortfolioIdPdpsPostError,
  Options<CreatePdpV1PortfoliosPortfolioIdPdpsPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreatePdpV1PortfoliosPortfolioIdPdpsPostResponse,
    CreatePdpV1PortfoliosPortfolioIdPdpsPostError,
    Options<CreatePdpV1PortfoliosPortfolioIdPdpsPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createPdpV1PortfoliosPortfolioIdPdpsPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Unlisted Pdp
 *
 * Creates a manually-entered PDP with user-provided data.
 * No external scraping. Item ID is auto-generated in VZT format.
 */
export const createUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostMutation = (
  options?: Partial<Options<CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostData>>,
): UseMutationOptions<
  CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostResponse,
  CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostError,
  Options<CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostResponse,
    CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostError,
    Options<CreateUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createUnlistedPdpV1PortfoliosPortfolioIdPdpsUnlistedPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetQueryKey = (
  options: Options<ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetData>,
) => createQueryKey('exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGet', options);

/**
 * Export Pdps Csv
 *
 * Download PDP search results as CSV with the standard column layout.
 */
export const exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetOptions = (
  options: Options<ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetData>,
) =>
  queryOptions<
    ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetResponse,
    ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetError,
    ExportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetResponse,
    ReturnType<typeof exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: exportPdpsCsvV1PortfoliosPortfolioIdPdpsExportGetQueryKey(options),
  });

/**
 * Delete Pdp
 *
 * Delete a PDP from a portfolio and all its associated images.
 */
export const deletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteMutation = (
  options?: Partial<Options<DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteData>>,
): UseMutationOptions<
  DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteResponse,
  DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteError,
  Options<DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteResponse,
    DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteError,
    Options<DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deletePdpV1PortfoliosPortfolioIdPdpsPdpIdDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPdpV1PortfoliosPortfolioIdPdpsPdpIdGetQueryKey = (
  options: Options<GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetData>,
) => createQueryKey('getPdpV1PortfoliosPortfolioIdPdpsPdpIdGet', options);

/**
 * Get Pdp
 */
export const getPdpV1PortfoliosPortfolioIdPdpsPdpIdGetOptions = (
  options: Options<GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetData>,
) =>
  queryOptions<
    GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetResponse,
    GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetError,
    GetPdpV1PortfoliosPortfolioIdPdpsPdpIdGetResponse,
    ReturnType<typeof getPdpV1PortfoliosPortfolioIdPdpsPdpIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPdpV1PortfoliosPortfolioIdPdpsPdpIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPdpV1PortfoliosPortfolioIdPdpsPdpIdGetQueryKey(options),
  });

/**
 * Update Pdp
 */
export const updatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutMutation = (
  options?: Partial<Options<UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutData>>,
): UseMutationOptions<
  UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutResponse,
  UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutError,
  Options<UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutResponse,
    UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutError,
    Options<UpdatePdpV1PortfoliosPortfolioIdPdpsPdpIdPutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updatePdpV1PortfoliosPortfolioIdPdpsPdpIdPut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Complex Search Pdps
 *
 * Complex PDP search with nested query conditions.
 *
 * Supports:
 * - Nested AND/OR logical conditions
 * - Multiple comparison operators (=, !=, >, >=, <, <=, like, ilike, in, not_in, is_null, is_not_null)
 * - Multi-field sorting
 * - Pagination
 *
 * Note: 'like' and 'ilike' automatically perform substring matching (no manual wildcards needed)
 *
 * Example request body:
 * ```json
 * {
 * "query": {
 * "operator": "and",
 * "conditions": [
 * {
 * "operator": "or",
 * "conditions": [
 * {"comparator": "=", "field": "brand", "value": "lindt"},
 * {"comparator": "ilike", "field": "name", "value": "lindt"}
 * ]
 * },
 * {
 * "comparator": "in",
 * "field": "product_category_id",
 * "value": ["uuid-1", "uuid-2"]
 * },
 * {
 * "comparator": "in",
 * "field": "listing_score_level",
 * "value": ["high", "very_high"]
 * }
 * ]
 * },
 * "order": [
 * {"field": "listing_score", "direction": "desc"}
 * ],
 * "pagination": {
 * "offset": 0,
 * "limit": 10
 * }
 * }
 * ```
 *
 * Available fields:
 * - brand, name, item_id, retailer, source_type, score_status
 * - listing_score, listing_score_at_ingest, raw_listing_score
 * - listing_score_level (use with 'in' comparator and values: very_low, low, moderate, high, very_high)
 * - product_category_id, product_category_name
 * - created_at, updated_at
 */
export const complexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostMutation = (
  options?: Partial<Options<ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostData>>,
): UseMutationOptions<
  ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostResponse,
  ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostError,
  Options<ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostData>
> => {
  const mutationOptions: UseMutationOptions<
    ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostResponse,
    ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostError,
    Options<ComplexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await complexSearchPdpsV1PortfoliosPortfolioIdPdpsSearchPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Pdp Title Brand
 *
 * Updates title and/or brand for manual PDPs only.
 * Returns 400 if PDP is scraped.
 */
export const updatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchMutation = (
  options?: Partial<Options<UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchData>>,
): UseMutationOptions<
  UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchResponse,
  UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchError,
  Options<UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchResponse,
    UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchError,
    Options<UpdatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatchData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updatePdpTitleBrandV1PortfoliosPortfolioIdPdpsPdpIdTitleBrandPatch({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetQueryKey = (
  options: Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>,
) => createQueryKey('searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGet', options);

/**
 * Search Pdp Images
 *
 * Retrieves images linked to a specific PDP with pagination support.
 * Default sort by PdpImage.created_at.
 */
export const searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetOptions = (
  options: Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>,
) =>
  queryOptions<
    SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetResponse,
    SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetError,
    SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetResponse,
    ReturnType<typeof searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetQueryKey(options),
  });

export const searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetInfiniteQueryKey = (
  options: Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>,
): QueryKey<Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>> =>
  createQueryKey('searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGet', options, true);

/**
 * Search Pdp Images
 *
 * Retrieves images linked to a specific PDP with pagination support.
 * Default sort by PdpImage.created_at.
 */
export const searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetInfiniteOptions = (
  options: Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>,
) =>
  infiniteQueryOptions<
    SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetResponse,
    SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetError,
    InfiniteData<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetResponse>,
    QueryKey<Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>>,
    | number
    | Pick<
        QueryKey<Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SearchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: searchPdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesGetInfiniteQueryKey(options),
    },
  );

/**
 * Create Pdp Image
 *
 * Creates an Image linked to a Pdp and returns the Image model
 */
export const createPdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostMutation = (
  options?: Partial<Options<CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostData>>,
): UseMutationOptions<
  CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostResponse,
  CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostError,
  Options<CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostResponse,
    CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostError,
    Options<CreatePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createPdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Bulk Create Pdp Images
 *
 * Creates multiple images linked to a PDP in a single transaction.
 *
 * Idempotency:
 * - If all requested images already exist (by name), returns them with 200
 * - If no images exist, creates all and returns 201
 * - If some exist and some don't, returns 409 Conflict
 */
export const bulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostMutation = (
  options?: Partial<Options<BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostData>>,
): UseMutationOptions<
  BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostResponse,
  BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostError,
  Options<BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostData>
> => {
  const mutationOptions: UseMutationOptions<
    BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostResponse,
    BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostError,
    Options<BulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await bulkCreatePdpImagesV1PortfoliosPortfolioIdPdpsPdpIdImagesBulkPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete Pdp Image
 *
 * Delete an image from a PDP. Cannot delete active hero or carousel images.
 */
export const deletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteMutation = (
  options?: Partial<Options<DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteData>>,
): UseMutationOptions<
  DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteResponse,
  DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteError,
  Options<DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteResponse,
    DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteError,
    Options<DeletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deletePdpImageV1PortfoliosPortfolioIdPdpsPdpIdImagesImageIdDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetQueryKey = (
  options: Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>,
) => createQueryKey('getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGet', options);

/**
 * Get Portfolio Brands
 *
 * Returns distinct brand values for PDPs in the portfolio.
 * Supports pagination and optional search filtering.
 */
export const getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetOptions = (
  options: Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>,
) =>
  queryOptions<
    GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetResponse,
    GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetError,
    GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetResponse,
    ReturnType<typeof getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetQueryKey(options),
  });

export const getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetInfiniteQueryKey = (
  options: Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>,
): QueryKey<Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>> =>
  createQueryKey('getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGet', options, true);

/**
 * Get Portfolio Brands
 *
 * Returns distinct brand values for PDPs in the portfolio.
 * Supports pagination and optional search filtering.
 */
export const getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetInfiniteOptions = (
  options: Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>,
) =>
  infiniteQueryOptions<
    GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetResponse,
    GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetError,
    InfiniteData<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetResponse>,
    QueryKey<Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>>,
    | number
    | Pick<
        QueryKey<Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getPortfolioBrandsV1PortfoliosPortfolioIdBrandsGetInfiniteQueryKey(options),
    },
  );

/**
 * Refresh Pdp
 */
export const refreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostMutation = (
  options?: Partial<Options<RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostData>>,
): UseMutationOptions<
  unknown,
  RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostError,
  Options<RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostError,
    Options<RefreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await refreshPdpV1PortfoliosPortfolioIdPdpsPdpIdRefreshPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Create Pdp Snapshot
 */
export const createPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostMutation = (
  options?: Partial<Options<CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostData>>,
): UseMutationOptions<
  CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostResponse,
  CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostError,
  Options<CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostData>
> => {
  const mutationOptions: UseMutationOptions<
    CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostResponse,
    CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostError,
    Options<CreatePdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await createPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Latest Snapshot Scores
 */
export const updateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutMutation = (
  options?: Partial<Options<UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutData>>,
): UseMutationOptions<
  UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutResponse,
  UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutError,
  Options<UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutResponse,
    UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutError,
    Options<UpdateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateLatestSnapshotScoresV1PortfoliosPortfolioIdPdpsPdpIdSnapshotsLatestScoresPut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetQueryKey = (
  options: Options<GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetData>,
) => createQueryKey('getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGet', options);

/**
 * Get Original Pdp Snapshot
 *
 * Get the most recent original PDP snapshot for before/after comparison.
 */
export const getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetOptions = (
  options: Options<GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetData>,
) =>
  queryOptions<
    GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetResponse,
    GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetError,
    GetOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetResponse,
    ReturnType<typeof getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOriginalPdpSnapshotV1PortfoliosPortfolioIdPdpsPdpIdOriginalGetQueryKey(options),
  });

export const getScrapedPdpV1PdpsRequestIdGetQueryKey = (options: Options<GetScrapedPdpV1PdpsRequestIdGetData>) =>
  createQueryKey('getScrapedPdpV1PdpsRequestIdGet', options);

/**
 * Get Scraped Pdp
 */
export const getScrapedPdpV1PdpsRequestIdGetOptions = (options: Options<GetScrapedPdpV1PdpsRequestIdGetData>) =>
  queryOptions<
    GetScrapedPdpV1PdpsRequestIdGetResponse,
    GetScrapedPdpV1PdpsRequestIdGetError,
    GetScrapedPdpV1PdpsRequestIdGetResponse,
    ReturnType<typeof getScrapedPdpV1PdpsRequestIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getScrapedPdpV1PdpsRequestIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getScrapedPdpV1PdpsRequestIdGetQueryKey(options),
  });

/**
 * Handle Category Not Found
 */
export const handleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostMutation = (
  options?: Partial<Options<HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostData>>,
): UseMutationOptions<
  unknown,
  HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostError,
  Options<HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostError,
    Options<HandleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await handleCategoryNotFoundV1PdpsPdpIdCategoryNotFoundPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getProductCategoriesV1ProductCategoriesGetQueryKey = (
  options?: Options<GetProductCategoriesV1ProductCategoriesGetData>,
) => createQueryKey('getProductCategoriesV1ProductCategoriesGet', options);

/**
 * Get Product Categories
 *
 * Retrieves the product categories for an organization
 * The product category names will be formatted in title-case
 *
 * Filters:
 * - breadcrumbs_like: Filter by breadcrumb path containing this string
 * - name_like: Filter by category name containing this string
 * - category_ids: Filter by specific category IDs
 * - scope_to_portfolio: Filter by categories used in PDPs or images for the current portfolio
 * - fallback: If true, try benchmark_lookup.json when no category_ids matches found
 */
export const getProductCategoriesV1ProductCategoriesGetOptions = (
  options?: Options<GetProductCategoriesV1ProductCategoriesGetData>,
) =>
  queryOptions<
    GetProductCategoriesV1ProductCategoriesGetResponse,
    GetProductCategoriesV1ProductCategoriesGetError,
    GetProductCategoriesV1ProductCategoriesGetResponse,
    ReturnType<typeof getProductCategoriesV1ProductCategoriesGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProductCategoriesV1ProductCategoriesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProductCategoriesV1ProductCategoriesGetQueryKey(options),
  });

export const getProductCategoriesV1ProductCategoriesGetInfiniteQueryKey = (
  options?: Options<GetProductCategoriesV1ProductCategoriesGetData>,
): QueryKey<Options<GetProductCategoriesV1ProductCategoriesGetData>> =>
  createQueryKey('getProductCategoriesV1ProductCategoriesGet', options, true);

/**
 * Get Product Categories
 *
 * Retrieves the product categories for an organization
 * The product category names will be formatted in title-case
 *
 * Filters:
 * - breadcrumbs_like: Filter by breadcrumb path containing this string
 * - name_like: Filter by category name containing this string
 * - category_ids: Filter by specific category IDs
 * - scope_to_portfolio: Filter by categories used in PDPs or images for the current portfolio
 * - fallback: If true, try benchmark_lookup.json when no category_ids matches found
 */
export const getProductCategoriesV1ProductCategoriesGetInfiniteOptions = (
  options?: Options<GetProductCategoriesV1ProductCategoriesGetData>,
) =>
  infiniteQueryOptions<
    GetProductCategoriesV1ProductCategoriesGetResponse,
    GetProductCategoriesV1ProductCategoriesGetError,
    InfiniteData<GetProductCategoriesV1ProductCategoriesGetResponse>,
    QueryKey<Options<GetProductCategoriesV1ProductCategoriesGetData>>,
    | number
    | Pick<QueryKey<Options<GetProductCategoriesV1ProductCategoriesGetData>>[0], 'body' | 'headers' | 'path' | 'query'>
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetProductCategoriesV1ProductCategoriesGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getProductCategoriesV1ProductCategoriesGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getProductCategoriesV1ProductCategoriesGetInfiniteQueryKey(options),
    },
  );

export const getProductCategoryV1ProductCategoriesCategoryIdGetQueryKey = (
  options: Options<GetProductCategoryV1ProductCategoriesCategoryIdGetData>,
) => createQueryKey('getProductCategoryV1ProductCategoriesCategoryIdGet', options);

/**
 * Get Product Category
 *
 * Retrieves a single product category by ID or breadcrumbs
 */
export const getProductCategoryV1ProductCategoriesCategoryIdGetOptions = (
  options: Options<GetProductCategoryV1ProductCategoriesCategoryIdGetData>,
) =>
  queryOptions<
    GetProductCategoryV1ProductCategoriesCategoryIdGetResponse,
    GetProductCategoryV1ProductCategoriesCategoryIdGetError,
    GetProductCategoryV1ProductCategoriesCategoryIdGetResponse,
    ReturnType<typeof getProductCategoryV1ProductCategoriesCategoryIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProductCategoryV1ProductCategoriesCategoryIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProductCategoryV1ProductCategoriesCategoryIdGetQueryKey(options),
  });

export const getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetQueryKey = (
  options: Options<GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetData>,
) => createQueryKey('getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGet', options);

/**
 * Get Product Category Audience Name
 *
 * Retrieves the audience name and version for a product category by UUID
 */
export const getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetOptions = (
  options: Options<GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetData>,
) =>
  queryOptions<
    GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetResponse,
    GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetError,
    GetProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetResponse,
    ReturnType<typeof getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getProductCategoryAudienceNameV1ProductCategoriesProductCategoryIdAudienceNameGetQueryKey(options),
  });

export const getIcpProductCategoriesV1IcpProductCategoriesGetQueryKey = (
  options?: Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>,
) => createQueryKey('getIcpProductCategoriesV1IcpProductCategoriesGet', options);

/**
 * Get Icp Product Categories
 */
export const getIcpProductCategoriesV1IcpProductCategoriesGetOptions = (
  options?: Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>,
) =>
  queryOptions<
    GetIcpProductCategoriesV1IcpProductCategoriesGetResponse,
    GetIcpProductCategoriesV1IcpProductCategoriesGetError,
    GetIcpProductCategoriesV1IcpProductCategoriesGetResponse,
    ReturnType<typeof getIcpProductCategoriesV1IcpProductCategoriesGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getIcpProductCategoriesV1IcpProductCategoriesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getIcpProductCategoriesV1IcpProductCategoriesGetQueryKey(options),
  });

export const getIcpProductCategoriesV1IcpProductCategoriesGetInfiniteQueryKey = (
  options?: Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>,
): QueryKey<Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>> =>
  createQueryKey('getIcpProductCategoriesV1IcpProductCategoriesGet', options, true);

/**
 * Get Icp Product Categories
 */
export const getIcpProductCategoriesV1IcpProductCategoriesGetInfiniteOptions = (
  options?: Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>,
) =>
  infiniteQueryOptions<
    GetIcpProductCategoriesV1IcpProductCategoriesGetResponse,
    GetIcpProductCategoriesV1IcpProductCategoriesGetError,
    InfiniteData<GetIcpProductCategoriesV1IcpProductCategoriesGetResponse>,
    QueryKey<Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>>,
    | number
    | Pick<
        QueryKey<Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetIcpProductCategoriesV1IcpProductCategoriesGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getIcpProductCategoriesV1IcpProductCategoriesGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getIcpProductCategoriesV1IcpProductCategoriesGetInfiniteQueryKey(options),
    },
  );

export const getIcpProductCategoriesV1L1ProductCategoriesGetQueryKey = (
  options?: Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>,
) => createQueryKey('getIcpProductCategoriesV1L1ProductCategoriesGet', options);

/**
 * Get Icp Product Categories
 *
 * @deprecated
 */
export const getIcpProductCategoriesV1L1ProductCategoriesGetOptions = (
  options?: Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>,
) =>
  queryOptions<
    GetIcpProductCategoriesV1L1ProductCategoriesGetResponse,
    GetIcpProductCategoriesV1L1ProductCategoriesGetError,
    GetIcpProductCategoriesV1L1ProductCategoriesGetResponse,
    ReturnType<typeof getIcpProductCategoriesV1L1ProductCategoriesGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getIcpProductCategoriesV1L1ProductCategoriesGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getIcpProductCategoriesV1L1ProductCategoriesGetQueryKey(options),
  });

export const getIcpProductCategoriesV1L1ProductCategoriesGetInfiniteQueryKey = (
  options?: Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>,
): QueryKey<Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>> =>
  createQueryKey('getIcpProductCategoriesV1L1ProductCategoriesGet', options, true);

/**
 * Get Icp Product Categories
 *
 * @deprecated
 */
export const getIcpProductCategoriesV1L1ProductCategoriesGetInfiniteOptions = (
  options?: Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>,
) =>
  infiniteQueryOptions<
    GetIcpProductCategoriesV1L1ProductCategoriesGetResponse,
    GetIcpProductCategoriesV1L1ProductCategoriesGetError,
    InfiniteData<GetIcpProductCategoriesV1L1ProductCategoriesGetResponse>,
    QueryKey<Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>>,
    | number
    | Pick<
        QueryKey<Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<GetIcpProductCategoriesV1L1ProductCategoriesGetData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  offset: pageParam,
                },
              };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await getIcpProductCategoriesV1L1ProductCategoriesGet({
          ...options,
          ...params,
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: getIcpProductCategoriesV1L1ProductCategoriesGetInfiniteQueryKey(options),
    },
  );

export const getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetQueryKey = (
  options: Options<GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetData>,
) => createQueryKey('getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGet', options);

/**
 * Get Icp Product Category
 *
 * @deprecated
 */
export const getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetOptions = (
  options: Options<GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetData>,
) =>
  queryOptions<
    GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetResponse,
    GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetError,
    GetIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetResponse,
    ReturnType<typeof getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getIcpProductCategoryV1L1ProductCategoriesIcpProductCategoryIdGetQueryKey(options),
  });

export const getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetQueryKey = (
  options: Options<GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetData>,
) => createQueryKey('getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGet', options);

/**
 * Get Icp Product Category
 */
export const getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetOptions = (
  options: Options<GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetData>,
) =>
  queryOptions<
    GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetResponse,
    GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetError,
    GetIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetResponse,
    ReturnType<typeof getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getIcpProductCategoryV1IcpProductCategoriesIcpProductCategoryIdGetQueryKey(options),
  });

export const getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetQueryKey = (
  options: Options<GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetData>,
) => createQueryKey('getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGet', options);

/**
 * Get Recommendations
 */
export const getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetOptions = (
  options: Options<GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetData>,
) =>
  queryOptions<
    GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetResponse,
    GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetError,
    GetRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetResponse,
    ReturnType<typeof getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRecommendationsV1PortfoliosPortfolioIdPdpsPdpIdRecommendationsGetQueryKey(options),
  });

export const listRetailerRegionsV1RetailerRegionsGetQueryKey = (
  options?: Options<ListRetailerRegionsV1RetailerRegionsGetData>,
) => createQueryKey('listRetailerRegionsV1RetailerRegionsGet', options);

/**
 * List Retailer Regions
 *
 * List all supported retailer/region combinations.
 */
export const listRetailerRegionsV1RetailerRegionsGetOptions = (
  options?: Options<ListRetailerRegionsV1RetailerRegionsGetData>,
) =>
  queryOptions<
    ListRetailerRegionsV1RetailerRegionsGetResponse,
    ListRetailerRegionsV1RetailerRegionsGetError,
    ListRetailerRegionsV1RetailerRegionsGetResponse,
    ReturnType<typeof listRetailerRegionsV1RetailerRegionsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listRetailerRegionsV1RetailerRegionsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: listRetailerRegionsV1RetailerRegionsGetQueryKey(options),
  });

export const getRetailerRegionV1RetailerRegionsRetailerRegionIdGetQueryKey = (
  options: Options<GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetData>,
) => createQueryKey('getRetailerRegionV1RetailerRegionsRetailerRegionIdGet', options);

/**
 * Get Retailer Region
 *
 * Get a specific retailer/region by ID (e.g., 'amazon_uk').
 */
export const getRetailerRegionV1RetailerRegionsRetailerRegionIdGetOptions = (
  options: Options<GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetData>,
) =>
  queryOptions<
    GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetResponse,
    GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetError,
    GetRetailerRegionV1RetailerRegionsRetailerRegionIdGetResponse,
    ReturnType<typeof getRetailerRegionV1RetailerRegionsRetailerRegionIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getRetailerRegionV1RetailerRegionsRetailerRegionIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getRetailerRegionV1RetailerRegionsRetailerRegionIdGetQueryKey(options),
  });

/**
 * Add User To Organization
 */
export const addUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostMutation = (
  options?: Partial<Options<AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostData>>,
): UseMutationOptions<
  AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostResponse,
  AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostError,
  Options<AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostData>
> => {
  const mutationOptions: UseMutationOptions<
    AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostResponse,
    AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostError,
    Options<AddUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await addUserToOrganizationV1OrganizationsOrganizationIdUsersEmailAddressPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Delete User
 */
export const deleteUserV1UsersUserIdDeleteMutation = (
  options?: Partial<Options<DeleteUserV1UsersUserIdDeleteData>>,
): UseMutationOptions<
  DeleteUserV1UsersUserIdDeleteResponse,
  DeleteUserV1UsersUserIdDeleteError,
  Options<DeleteUserV1UsersUserIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    DeleteUserV1UsersUserIdDeleteResponse,
    DeleteUserV1UsersUserIdDeleteError,
    Options<DeleteUserV1UsersUserIdDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await deleteUserV1UsersUserIdDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getUserV1UsersUserIdGetQueryKey = (options: Options<GetUserV1UsersUserIdGetData>) =>
  createQueryKey('getUserV1UsersUserIdGet', options);

/**
 * Get User
 */
export const getUserV1UsersUserIdGetOptions = (options: Options<GetUserV1UsersUserIdGetData>) =>
  queryOptions<
    GetUserV1UsersUserIdGetResponse,
    GetUserV1UsersUserIdGetError,
    GetUserV1UsersUserIdGetResponse,
    ReturnType<typeof getUserV1UsersUserIdGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getUserV1UsersUserIdGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getUserV1UsersUserIdGetQueryKey(options),
  });

/**
 * Set Password
 */
export const setPasswordV1UsersUserIdPasswordPostMutation = (
  options?: Partial<Options<SetPasswordV1UsersUserIdPasswordPostData>>,
): UseMutationOptions<
  SetPasswordV1UsersUserIdPasswordPostResponse,
  SetPasswordV1UsersUserIdPasswordPostError,
  Options<SetPasswordV1UsersUserIdPasswordPostData>
> => {
  const mutationOptions: UseMutationOptions<
    SetPasswordV1UsersUserIdPasswordPostResponse,
    SetPasswordV1UsersUserIdPasswordPostError,
    Options<SetPasswordV1UsersUserIdPasswordPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await setPasswordV1UsersUserIdPasswordPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Reset Password
 */
export const resetPasswordV1UsersPasswordPutMutation = (
  options?: Partial<Options<ResetPasswordV1UsersPasswordPutData>>,
): UseMutationOptions<unknown, ResetPasswordV1UsersPasswordPutError, Options<ResetPasswordV1UsersPasswordPutData>> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    ResetPasswordV1UsersPasswordPutError,
    Options<ResetPasswordV1UsersPasswordPutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await resetPasswordV1UsersPasswordPut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Login User
 */
export const loginUserV1UsersAuthenticatePostMutation = (
  options?: Partial<Options<LoginUserV1UsersAuthenticatePostData>>,
): UseMutationOptions<
  LoginUserV1UsersAuthenticatePostResponse,
  LoginUserV1UsersAuthenticatePostError,
  Options<LoginUserV1UsersAuthenticatePostData>
> => {
  const mutationOptions: UseMutationOptions<
    LoginUserV1UsersAuthenticatePostResponse,
    LoginUserV1UsersAuthenticatePostError,
    Options<LoginUserV1UsersAuthenticatePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await loginUserV1UsersAuthenticatePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Exchange Token
 */
export const exchangeTokenV1OrganizationsOrganizationIdAuthorizePostMutation = (
  options?: Partial<Options<ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostData>>,
): UseMutationOptions<
  ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostResponse,
  ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostError,
  Options<ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostData>
> => {
  const mutationOptions: UseMutationOptions<
    ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostResponse,
    ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostError,
    Options<ExchangeTokenV1OrganizationsOrganizationIdAuthorizePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await exchangeTokenV1OrganizationsOrganizationIdAuthorizePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Remove User From Organization
 */
export const removeUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteMutation = (
  options?: Partial<Options<RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteData>>,
): UseMutationOptions<
  RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteResponse,
  RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteError,
  Options<RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteData>
> => {
  const mutationOptions: UseMutationOptions<
    RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteResponse,
    RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteError,
    Options<RemoveUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDeleteData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await removeUserFromOrganizationV1OrganizationsOrganizationIdUsersUserIdDelete({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const getOrganizationsForUserV1UsersUserIdOrganizationsGetQueryKey = (
  options: Options<GetOrganizationsForUserV1UsersUserIdOrganizationsGetData>,
) => createQueryKey('getOrganizationsForUserV1UsersUserIdOrganizationsGet', options);

/**
 * Get Organizations For User
 */
export const getOrganizationsForUserV1UsersUserIdOrganizationsGetOptions = (
  options: Options<GetOrganizationsForUserV1UsersUserIdOrganizationsGetData>,
) =>
  queryOptions<
    GetOrganizationsForUserV1UsersUserIdOrganizationsGetResponse,
    GetOrganizationsForUserV1UsersUserIdOrganizationsGetError,
    GetOrganizationsForUserV1UsersUserIdOrganizationsGetResponse,
    ReturnType<typeof getOrganizationsForUserV1UsersUserIdOrganizationsGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await getOrganizationsForUserV1UsersUserIdOrganizationsGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: getOrganizationsForUserV1UsersUserIdOrganizationsGetQueryKey(options),
  });

/**
 * Logout User
 */
export const logoutUserV1UsersUserIdLogoutPostMutation = (
  options?: Partial<Options<LogoutUserV1UsersUserIdLogoutPostData>>,
): UseMutationOptions<
  unknown,
  LogoutUserV1UsersUserIdLogoutPostError,
  Options<LogoutUserV1UsersUserIdLogoutPostData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    LogoutUserV1UsersUserIdLogoutPostError,
    Options<LogoutUserV1UsersUserIdLogoutPostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await logoutUserV1UsersUserIdLogoutPost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Resend Invite
 */
export const resendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostMutation = (
  options?: Partial<Options<ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostData>>,
): UseMutationOptions<
  ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostResponse,
  ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostError,
  Options<ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostData>
> => {
  const mutationOptions: UseMutationOptions<
    ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostResponse,
    ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostError,
    Options<ResendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePostData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await resendInviteV1OrganizationsOrganizationIdUsersUserIdResendInvitePost({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

/**
 * Update Retailer Preference
 */
export const updateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutMutation = (
  options?: Partial<Options<UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutData>>,
): UseMutationOptions<
  UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutResponse,
  UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutError,
  Options<UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutData>
> => {
  const mutationOptions: UseMutationOptions<
    UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutResponse,
    UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutError,
    Options<UpdateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePutData>
  > = {
    mutationFn: async (fnOptions) => {
      const { data } = await updateRetailerPreferenceV1OrganizationsOrganizationIdUsersUserIdRetailerPreferencePut({
        ...options,
        ...fnOptions,
        throwOnError: true,
      });
      return data;
    },
  };
  return mutationOptions;
};

export const healthcheckHealthcheckGetQueryKey = (options?: Options<HealthcheckHealthcheckGetData>) =>
  createQueryKey('healthcheckHealthcheckGet', options);

/**
 * Healthcheck
 *
 * A simple endpoint to ping the server and get a response
 */
export const healthcheckHealthcheckGetOptions = (options?: Options<HealthcheckHealthcheckGetData>) =>
  queryOptions<
    HealthcheckHealthcheckGetResponse,
    DefaultError,
    HealthcheckHealthcheckGetResponse,
    ReturnType<typeof healthcheckHealthcheckGetQueryKey>
  >({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await healthcheckHealthcheckGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: healthcheckHealthcheckGetQueryKey(options),
  });

export const healthcheckGetQueryKey = (options?: Options<HealthcheckGetData>) =>
  createQueryKey('healthcheckGet', options);

/**
 * Healthcheck
 *
 * A simple endpoint to ping the server and get a response
 */
export const healthcheckGetOptions = (options?: Options<HealthcheckGetData>) =>
  queryOptions<HealthcheckGetResponse, DefaultError, HealthcheckGetResponse, ReturnType<typeof healthcheckGetQueryKey>>(
    {
      queryFn: async ({ queryKey, signal }) => {
        const { data } = await healthcheckGet({
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true,
        });
        return data;
      },
      queryKey: healthcheckGetQueryKey(options),
    },
  );

export const readyReadyGetQueryKey = (options?: Options<ReadyReadyGetData>) => createQueryKey('readyReadyGet', options);

/**
 * Ready
 *
 * Check the state of the API and the services it depends on
 */
export const readyReadyGetOptions = (options?: Options<ReadyReadyGetData>) =>
  queryOptions<ReadyReadyGetResponse, DefaultError, ReadyReadyGetResponse, ReturnType<typeof readyReadyGetQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await readyReadyGet({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true,
      });
      return data;
    },
    queryKey: readyReadyGetQueryKey(options),
  });
